(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
(function (global){
(function (cb){
  var w;
  try {
    w = window;
  } catch (e) {
    w = global;
  }

  var queue = w._async_define_queue = '_async_define_queue' in w ? w._async_define_queue : [];
  var cached_dependencies = w._async_define_cached_dependencies = '_async_define_cached_dependencies' in w ? w._async_define_cached_dependencies : {};

  function getDepsArray(depNames) {
    var i,
      tmp, depNS, depProp,
      len = depNames.length,
      deps = [];

    for (i = 0; i < len; i++) {
      tmp = depNames[i].split('|');
      depNS = tmp[0];
      depProp = tmp[1];
      if (depNS in cached_dependencies){
        deps.push(depProp ? cached_dependencies[depNS][depProp] : cached_dependencies[depNS]);
      }
      else {
        return;
      }
    }
    return deps;
  }

  function runThroughQueue() {
    while (_runThroughQueue());
  }

  function _runThroughQueue() {
    var i = 0;
    var solvedDependency = false;
    while (i < queue.length){
      if (execute(queue[i])){
        if (queue[i].name){
          solvedDependency = true;
        }
        queue.splice(i, 1);
      }
      else {
        i++;
      }
    }
    return solvedDependency;
  }

  function execute (item){
    if (item.name in cached_dependencies) { // don't execute twice
      return true;
    }
    var deps = getDepsArray(item.depNames);
    var exp;
    if (deps){
      exp = item.func.apply(w, deps);
      if (item.name){
        cached_dependencies[item.name] = exp;
      }
      return true;
    }
    else {
      return;
    }
  }

  function wrapObj (o){
    if (typeof o === 'function'){
      return o;
    }
    else {
      return function (){
        return o;
      };
    }
  }

  function ad() {
    var item = {
        name:  typeof arguments[0] === 'string' ? arguments[0] : undefined,
        depNames: Array.isArray(arguments[0]) ? arguments[0] : Array.isArray(arguments[1]) ? arguments[1] : [],
        func: wrapObj(arguments[arguments.length - 1])
    };
    if (!execute(item)){
      queue.push(item);
    }
    else {
      if (item.name){
        runThroughQueue(); // executed straight away, try to resolve func that depends on this
      }
    }
  }
  cb.call(w, ad);
}(function (define) {
  if (typeof exports === 'object'){
  module.exports = define;
}
else{
  this.asyncDefine = define;
}

}));


}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],2:[function(require,module,exports){
require('async-define')(["jquery-1.11"],function (__jquery){

});
},{"async-define":1}],3:[function(require,module,exports){
require('async-define')(["jquery-1.11"],function (__jquery){
"use strict";
/*globals Handlebars: true */
var Handlebars = require("./handlebars.runtime")["default"];

// Compiler imports
var AST = require("./handlebars/compiler/ast")["default"];
var Parser = require("./handlebars/compiler/base").parser;
var parse = require("./handlebars/compiler/base").parse;
var Compiler = require("./handlebars/compiler/compiler").Compiler;
var compile = require("./handlebars/compiler/compiler").compile;
var precompile = require("./handlebars/compiler/compiler").precompile;
var JavaScriptCompiler = require("./handlebars/compiler/javascript-compiler")["default"];

var _create = Handlebars.create;
var create = function() {
  var hb = _create();

  hb.compile = function(input, options) {
    return compile(input, options, hb);
  };
  hb.precompile = function (input, options) {
    return precompile(input, options, hb);
  };

  hb.AST = AST;
  hb.Compiler = Compiler;
  hb.JavaScriptCompiler = JavaScriptCompiler;
  hb.Parser = Parser;
  hb.parse = parse;

  return hb;
};

Handlebars = create();
Handlebars.create = create;

Handlebars['default'] = Handlebars;

exports["default"] = Handlebars;
});
},{"./handlebars.runtime":4,"./handlebars/compiler/ast":6,"./handlebars/compiler/base":7,"./handlebars/compiler/compiler":8,"./handlebars/compiler/javascript-compiler":10,"async-define":1}],4:[function(require,module,exports){
require('async-define')(["jquery-1.11"],function (__jquery){
"use strict";
/*globals Handlebars: true */
var base = require("./handlebars/base");

// Each of these augment the Handlebars object. No need to setup here.
// (This is done to easily share code between commonjs and browse envs)
var SafeString = require("./handlebars/safe-string")["default"];
var Exception = require("./handlebars/exception")["default"];
var Utils = require("./handlebars/utils");
var runtime = require("./handlebars/runtime");

// For compatibility and usage outside of module systems, make the Handlebars object a namespace
var create = function() {
  var hb = new base.HandlebarsEnvironment();

  Utils.extend(hb, base);
  hb.SafeString = SafeString;
  hb.Exception = Exception;
  hb.Utils = Utils;
  hb.escapeExpression = Utils.escapeExpression;

  hb.VM = runtime;
  hb.template = function(spec) {
    return runtime.template(spec, hb);
  };

  return hb;
};

var Handlebars = create();
Handlebars.create = create;

Handlebars['default'] = Handlebars;

exports["default"] = Handlebars;
});
},{"./handlebars/base":5,"./handlebars/exception":14,"./handlebars/runtime":15,"./handlebars/safe-string":16,"./handlebars/utils":17,"async-define":1}],5:[function(require,module,exports){
require('async-define')(["jquery-1.11"],function (__jquery){
"use strict";
var Utils = require("./utils");
var Exception = require("./exception")["default"];

var VERSION = "2.0.0";
exports.VERSION = VERSION;var COMPILER_REVISION = 6;
exports.COMPILER_REVISION = COMPILER_REVISION;
var REVISION_CHANGES = {
  1: '<= 1.0.rc.2', // 1.0.rc.2 is actually rev2 but doesn't report it
  2: '== 1.0.0-rc.3',
  3: '== 1.0.0-rc.4',
  4: '== 1.x.x',
  5: '== 2.0.0-alpha.x',
  6: '>= 2.0.0-beta.1'
};
exports.REVISION_CHANGES = REVISION_CHANGES;
var isArray = Utils.isArray,
    isFunction = Utils.isFunction,
    toString = Utils.toString,
    objectType = '[object Object]';

function HandlebarsEnvironment(helpers, partials) {
  this.helpers = helpers || {};
  this.partials = partials || {};

  registerDefaultHelpers(this);
}

exports.HandlebarsEnvironment = HandlebarsEnvironment;HandlebarsEnvironment.prototype = {
  constructor: HandlebarsEnvironment,

  logger: logger,
  log: log,

  registerHelper: function(name, fn) {
    if (toString.call(name) === objectType) {
      if (fn) { throw new Exception('Arg not supported with multiple helpers'); }
      Utils.extend(this.helpers, name);
    } else {
      this.helpers[name] = fn;
    }
  },
  unregisterHelper: function(name) {
    delete this.helpers[name];
  },

  registerPartial: function(name, partial) {
    if (toString.call(name) === objectType) {
      Utils.extend(this.partials,  name);
    } else {
      this.partials[name] = partial;
    }
  },
  unregisterPartial: function(name) {
    delete this.partials[name];
  }
};

function registerDefaultHelpers(instance) {
  instance.registerHelper('helperMissing', function(/* [args, ]options */) {
    if(arguments.length === 1) {
      // A missing field in a {{foo}} constuct.
      return undefined;
    } else {
      // Someone is actually trying to call something, blow up.
      throw new Exception("Missing helper: '" + arguments[arguments.length-1].name + "'");
    }
  });

  instance.registerHelper('blockHelperMissing', function(context, options) {
    var inverse = options.inverse,
        fn = options.fn;

    if(context === true) {
      return fn(this);
    } else if(context === false || context == null) {
      return inverse(this);
    } else if (isArray(context)) {
      if(context.length > 0) {
        if (options.ids) {
          options.ids = [options.name];
        }

        return instance.helpers.each(context, options);
      } else {
        return inverse(this);
      }
    } else {
      if (options.data && options.ids) {
        var data = createFrame(options.data);
        data.contextPath = Utils.appendContextPath(options.data.contextPath, options.name);
        options = {data: data};
      }

      return fn(context, options);
    }
  });

  instance.registerHelper('each', function(context, options) {
    if (!options) {
      throw new Exception('Must pass iterator to #each');
    }

    var fn = options.fn, inverse = options.inverse;
    var i = 0, ret = "", data;

    var contextPath;
    if (options.data && options.ids) {
      contextPath = Utils.appendContextPath(options.data.contextPath, options.ids[0]) + '.';
    }

    if (isFunction(context)) { context = context.call(this); }

    if (options.data) {
      data = createFrame(options.data);
    }

    if(context && typeof context === 'object') {
      if (isArray(context)) {
        for(var j = context.length; i<j; i++) {
          if (data) {
            data.index = i;
            data.first = (i === 0);
            data.last  = (i === (context.length-1));

            if (contextPath) {
              data.contextPath = contextPath + i;
            }
          }
          ret = ret + fn(context[i], { data: data });
        }
      } else {
        for(var key in context) {
          if(context.hasOwnProperty(key)) {
            if(data) {
              data.key = key;
              data.index = i;
              data.first = (i === 0);

              if (contextPath) {
                data.contextPath = contextPath + key;
              }
            }
            ret = ret + fn(context[key], {data: data});
            i++;
          }
        }
      }
    }

    if(i === 0){
      ret = inverse(this);
    }

    return ret;
  });

  instance.registerHelper('if', function(conditional, options) {
    if (isFunction(conditional)) { conditional = conditional.call(this); }

    // Default behavior is to render the positive path if the value is truthy and not empty.
    // The `includeZero` option may be set to treat the condtional as purely not empty based on the
    // behavior of isEmpty. Effectively this determines if 0 is handled by the positive path or negative.
    if ((!options.hash.includeZero && !conditional) || Utils.isEmpty(conditional)) {
      return options.inverse(this);
    } else {
      return options.fn(this);
    }
  });

  instance.registerHelper('unless', function(conditional, options) {
    return instance.helpers['if'].call(this, conditional, {fn: options.inverse, inverse: options.fn, hash: options.hash});
  });

  instance.registerHelper('with', function(context, options) {
    if (isFunction(context)) { context = context.call(this); }

    var fn = options.fn;

    if (!Utils.isEmpty(context)) {
      if (options.data && options.ids) {
        var data = createFrame(options.data);
        data.contextPath = Utils.appendContextPath(options.data.contextPath, options.ids[0]);
        options = {data:data};
      }

      return fn(context, options);
    } else {
      return options.inverse(this);
    }
  });

  instance.registerHelper('log', function(message, options) {
    var level = options.data && options.data.level != null ? parseInt(options.data.level, 10) : 1;
    instance.log(level, message);
  });

  instance.registerHelper('lookup', function(obj, field) {
    return obj && obj[field];
  });
}

var logger = {
  methodMap: { 0: 'debug', 1: 'info', 2: 'warn', 3: 'error' },

  // State enum
  DEBUG: 0,
  INFO: 1,
  WARN: 2,
  ERROR: 3,
  level: 3,

  // can be overridden in the host environment
  log: function(level, message) {
    if (logger.level <= level) {
      var method = logger.methodMap[level];
      if (typeof console !== 'undefined' && console[method]) {
        console[method].call(console, message);
      }
    }
  }
};
exports.logger = logger;
var log = logger.log;
exports.log = log;
var createFrame = function(object) {
  var frame = Utils.extend({}, object);
  frame._parent = object;
  return frame;
};
exports.createFrame = createFrame;
});
},{"./exception":14,"./utils":17,"async-define":1}],6:[function(require,module,exports){
require('async-define')(["jquery-1.11"],function (__jquery){
"use strict";
var Exception = require("../exception")["default"];

function LocationInfo(locInfo) {
  locInfo = locInfo || {};
  this.firstLine   = locInfo.first_line;
  this.firstColumn = locInfo.first_column;
  this.lastColumn  = locInfo.last_column;
  this.lastLine    = locInfo.last_line;
}

var AST = {
  ProgramNode: function(statements, strip, locInfo) {
    LocationInfo.call(this, locInfo);
    this.type = "program";
    this.statements = statements;
    this.strip = strip;
  },

  MustacheNode: function(rawParams, hash, open, strip, locInfo) {
    LocationInfo.call(this, locInfo);
    this.type = "mustache";
    this.strip = strip;

    // Open may be a string parsed from the parser or a passed boolean flag
    if (open != null && open.charAt) {
      // Must use charAt to support IE pre-10
      var escapeFlag = open.charAt(3) || open.charAt(2);
      this.escaped = escapeFlag !== '{' && escapeFlag !== '&';
    } else {
      this.escaped = !!open;
    }

    if (rawParams instanceof AST.SexprNode) {
      this.sexpr = rawParams;
    } else {
      // Support old AST API
      this.sexpr = new AST.SexprNode(rawParams, hash);
    }

    // Support old AST API that stored this info in MustacheNode
    this.id = this.sexpr.id;
    this.params = this.sexpr.params;
    this.hash = this.sexpr.hash;
    this.eligibleHelper = this.sexpr.eligibleHelper;
    this.isHelper = this.sexpr.isHelper;
  },

  SexprNode: function(rawParams, hash, locInfo) {
    LocationInfo.call(this, locInfo);

    this.type = "sexpr";
    this.hash = hash;

    var id = this.id = rawParams[0];
    var params = this.params = rawParams.slice(1);

    // a mustache is definitely a helper if:
    // * it is an eligible helper, and
    // * it has at least one parameter or hash segment
    this.isHelper = !!(params.length || hash);

    // a mustache is an eligible helper if:
    // * its id is simple (a single part, not `this` or `..`)
    this.eligibleHelper = this.isHelper || id.isSimple;

    // if a mustache is an eligible helper but not a definite
    // helper, it is ambiguous, and will be resolved in a later
    // pass or at runtime.
  },

  PartialNode: function(partialName, context, hash, strip, locInfo) {
    LocationInfo.call(this, locInfo);
    this.type         = "partial";
    this.partialName  = partialName;
    this.context      = context;
    this.hash = hash;
    this.strip = strip;

    this.strip.inlineStandalone = true;
  },

  BlockNode: function(mustache, program, inverse, strip, locInfo) {
    LocationInfo.call(this, locInfo);

    this.type = 'block';
    this.mustache = mustache;
    this.program  = program;
    this.inverse  = inverse;
    this.strip = strip;

    if (inverse && !program) {
      this.isInverse = true;
    }
  },

  RawBlockNode: function(mustache, content, close, locInfo) {
    LocationInfo.call(this, locInfo);

    if (mustache.sexpr.id.original !== close) {
      throw new Exception(mustache.sexpr.id.original + " doesn't match " + close, this);
    }

    content = new AST.ContentNode(content, locInfo);

    this.type = 'block';
    this.mustache = mustache;
    this.program = new AST.ProgramNode([content], {}, locInfo);
  },

  ContentNode: function(string, locInfo) {
    LocationInfo.call(this, locInfo);
    this.type = "content";
    this.original = this.string = string;
  },

  HashNode: function(pairs, locInfo) {
    LocationInfo.call(this, locInfo);
    this.type = "hash";
    this.pairs = pairs;
  },

  IdNode: function(parts, locInfo) {
    LocationInfo.call(this, locInfo);
    this.type = "ID";

    var original = "",
        dig = [],
        depth = 0,
        depthString = '';

    for(var i=0,l=parts.length; i<l; i++) {
      var part = parts[i].part;
      original += (parts[i].separator || '') + part;

      if (part === ".." || part === "." || part === "this") {
        if (dig.length > 0) {
          throw new Exception("Invalid path: " + original, this);
        } else if (part === "..") {
          depth++;
          depthString += '../';
        } else {
          this.isScoped = true;
        }
      } else {
        dig.push(part);
      }
    }

    this.original = original;
    this.parts    = dig;
    this.string   = dig.join('.');
    this.depth    = depth;
    this.idName   = depthString + this.string;

    // an ID is simple if it only has one part, and that part is not
    // `..` or `this`.
    this.isSimple = parts.length === 1 && !this.isScoped && depth === 0;

    this.stringModeValue = this.string;
  },

  PartialNameNode: function(name, locInfo) {
    LocationInfo.call(this, locInfo);
    this.type = "PARTIAL_NAME";
    this.name = name.original;
  },

  DataNode: function(id, locInfo) {
    LocationInfo.call(this, locInfo);
    this.type = "DATA";
    this.id = id;
    this.stringModeValue = id.stringModeValue;
    this.idName = '@' + id.stringModeValue;
  },

  StringNode: function(string, locInfo) {
    LocationInfo.call(this, locInfo);
    this.type = "STRING";
    this.original =
      this.string =
      this.stringModeValue = string;
  },

  NumberNode: function(number, locInfo) {
    LocationInfo.call(this, locInfo);
    this.type = "NUMBER";
    this.original =
      this.number = number;
    this.stringModeValue = Number(number);
  },

  BooleanNode: function(bool, locInfo) {
    LocationInfo.call(this, locInfo);
    this.type = "BOOLEAN";
    this.bool = bool;
    this.stringModeValue = bool === "true";
  },

  CommentNode: function(comment, locInfo) {
    LocationInfo.call(this, locInfo);
    this.type = "comment";
    this.comment = comment;

    this.strip = {
      inlineStandalone: true
    };
  }
};


// Must be exported as an object rather than the root of the module as the jison lexer
// most modify the object to operate properly.
exports["default"] = AST;
});
},{"../exception":14,"async-define":1}],7:[function(require,module,exports){
require('async-define')(["jquery-1.11"],function (__jquery){
"use strict";
var parser = require("./parser")["default"];
var AST = require("./ast")["default"];
var Helpers = require("./helpers");
var extend = require("../utils").extend;

exports.parser = parser;

var yy = {};
extend(yy, Helpers, AST);

function parse(input) {
  // Just return if an already-compile AST was passed in.
  if (input.constructor === AST.ProgramNode) { return input; }

  parser.yy = yy;

  return parser.parse(input);
}

exports.parse = parse;
});
},{"../utils":17,"./ast":6,"./helpers":9,"./parser":11,"async-define":1}],8:[function(require,module,exports){
require('async-define')(["jquery-1.11"],function (__jquery){
"use strict";
var Exception = require("../exception")["default"];
var isArray = require("../utils").isArray;

var slice = [].slice;

function Compiler() {}

exports.Compiler = Compiler;// the foundHelper register will disambiguate helper lookup from finding a
// function in a context. This is necessary for mustache compatibility, which
// requires that context functions in blocks are evaluated by blockHelperMissing,
// and then proceed as if the resulting value was provided to blockHelperMissing.

Compiler.prototype = {
  compiler: Compiler,

  equals: function(other) {
    var len = this.opcodes.length;
    if (other.opcodes.length !== len) {
      return false;
    }

    for (var i = 0; i < len; i++) {
      var opcode = this.opcodes[i],
          otherOpcode = other.opcodes[i];
      if (opcode.opcode !== otherOpcode.opcode || !argEquals(opcode.args, otherOpcode.args)) {
        return false;
      }
    }

    // We know that length is the same between the two arrays because they are directly tied
    // to the opcode behavior above.
    len = this.children.length;
    for (i = 0; i < len; i++) {
      if (!this.children[i].equals(other.children[i])) {
        return false;
      }
    }

    return true;
  },

  guid: 0,

  compile: function(program, options) {
    this.opcodes = [];
    this.children = [];
    this.depths = {list: []};
    this.options = options;
    this.stringParams = options.stringParams;
    this.trackIds = options.trackIds;

    // These changes will propagate to the other compiler components
    var knownHelpers = this.options.knownHelpers;
    this.options.knownHelpers = {
      'helperMissing': true,
      'blockHelperMissing': true,
      'each': true,
      'if': true,
      'unless': true,
      'with': true,
      'log': true,
      'lookup': true
    };
    if (knownHelpers) {
      for (var name in knownHelpers) {
        this.options.knownHelpers[name] = knownHelpers[name];
      }
    }

    return this.accept(program);
  },

  accept: function(node) {
    return this[node.type](node);
  },

  program: function(program) {
    var statements = program.statements;

    for(var i=0, l=statements.length; i<l; i++) {
      this.accept(statements[i]);
    }
    this.isSimple = l === 1;

    this.depths.list = this.depths.list.sort(function(a, b) {
      return a - b;
    });

    return this;
  },

  compileProgram: function(program) {
    var result = new this.compiler().compile(program, this.options);
    var guid = this.guid++, depth;

    this.usePartial = this.usePartial || result.usePartial;

    this.children[guid] = result;

    for(var i=0, l=result.depths.list.length; i<l; i++) {
      depth = result.depths.list[i];

      if(depth < 2) { continue; }
      else { this.addDepth(depth - 1); }
    }

    return guid;
  },

  block: function(block) {
    var mustache = block.mustache,
        program = block.program,
        inverse = block.inverse;

    if (program) {
      program = this.compileProgram(program);
    }

    if (inverse) {
      inverse = this.compileProgram(inverse);
    }

    var sexpr = mustache.sexpr;
    var type = this.classifySexpr(sexpr);

    if (type === "helper") {
      this.helperSexpr(sexpr, program, inverse);
    } else if (type === "simple") {
      this.simpleSexpr(sexpr);

      // now that the simple mustache is resolved, we need to
      // evaluate it by executing `blockHelperMissing`
      this.opcode('pushProgram', program);
      this.opcode('pushProgram', inverse);
      this.opcode('emptyHash');
      this.opcode('blockValue', sexpr.id.original);
    } else {
      this.ambiguousSexpr(sexpr, program, inverse);

      // now that the simple mustache is resolved, we need to
      // evaluate it by executing `blockHelperMissing`
      this.opcode('pushProgram', program);
      this.opcode('pushProgram', inverse);
      this.opcode('emptyHash');
      this.opcode('ambiguousBlockValue');
    }

    this.opcode('append');
  },

  hash: function(hash) {
    var pairs = hash.pairs, i, l;

    this.opcode('pushHash');

    for(i=0, l=pairs.length; i<l; i++) {
      this.pushParam(pairs[i][1]);
    }
    while(i--) {
      this.opcode('assignToHash', pairs[i][0]);
    }
    this.opcode('popHash');
  },

  partial: function(partial) {
    var partialName = partial.partialName;
    this.usePartial = true;

    if (partial.hash) {
      this.accept(partial.hash);
    } else {
      this.opcode('push', 'undefined');
    }

    if (partial.context) {
      this.accept(partial.context);
    } else {
      this.opcode('getContext', 0);
      this.opcode('pushContext');
    }

    this.opcode('invokePartial', partialName.name, partial.indent || '');
    this.opcode('append');
  },

  content: function(content) {
    if (content.string) {
      this.opcode('appendContent', content.string);
    }
  },

  mustache: function(mustache) {
    this.sexpr(mustache.sexpr);

    if(mustache.escaped && !this.options.noEscape) {
      this.opcode('appendEscaped');
    } else {
      this.opcode('append');
    }
  },

  ambiguousSexpr: function(sexpr, program, inverse) {
    var id = sexpr.id,
        name = id.parts[0],
        isBlock = program != null || inverse != null;

    this.opcode('getContext', id.depth);

    this.opcode('pushProgram', program);
    this.opcode('pushProgram', inverse);

    this.ID(id);

    this.opcode('invokeAmbiguous', name, isBlock);
  },

  simpleSexpr: function(sexpr) {
    var id = sexpr.id;

    if (id.type === 'DATA') {
      this.DATA(id);
    } else if (id.parts.length) {
      this.ID(id);
    } else {
      // Simplified ID for `this`
      this.addDepth(id.depth);
      this.opcode('getContext', id.depth);
      this.opcode('pushContext');
    }

    this.opcode('resolvePossibleLambda');
  },

  helperSexpr: function(sexpr, program, inverse) {
    var params = this.setupFullMustacheParams(sexpr, program, inverse),
        id = sexpr.id,
        name = id.parts[0];

    if (this.options.knownHelpers[name]) {
      this.opcode('invokeKnownHelper', params.length, name);
    } else if (this.options.knownHelpersOnly) {
      throw new Exception("You specified knownHelpersOnly, but used the unknown helper " + name, sexpr);
    } else {
      id.falsy = true;

      this.ID(id);
      this.opcode('invokeHelper', params.length, id.original, id.isSimple);
    }
  },

  sexpr: function(sexpr) {
    var type = this.classifySexpr(sexpr);

    if (type === "simple") {
      this.simpleSexpr(sexpr);
    } else if (type === "helper") {
      this.helperSexpr(sexpr);
    } else {
      this.ambiguousSexpr(sexpr);
    }
  },

  ID: function(id) {
    this.addDepth(id.depth);
    this.opcode('getContext', id.depth);

    var name = id.parts[0];
    if (!name) {
      // Context reference, i.e. `{{foo .}}` or `{{foo ..}}`
      this.opcode('pushContext');
    } else {
      this.opcode('lookupOnContext', id.parts, id.falsy, id.isScoped);
    }
  },

  DATA: function(data) {
    this.options.data = true;
    this.opcode('lookupData', data.id.depth, data.id.parts);
  },

  STRING: function(string) {
    this.opcode('pushString', string.string);
  },

  NUMBER: function(number) {
    this.opcode('pushLiteral', number.number);
  },

  BOOLEAN: function(bool) {
    this.opcode('pushLiteral', bool.bool);
  },

  comment: function() {},

  // HELPERS
  opcode: function(name) {
    this.opcodes.push({ opcode: name, args: slice.call(arguments, 1) });
  },

  addDepth: function(depth) {
    if(depth === 0) { return; }

    if(!this.depths[depth]) {
      this.depths[depth] = true;
      this.depths.list.push(depth);
    }
  },

  classifySexpr: function(sexpr) {
    var isHelper   = sexpr.isHelper;
    var isEligible = sexpr.eligibleHelper;
    var options    = this.options;

    // if ambiguous, we can possibly resolve the ambiguity now
    // An eligible helper is one that does not have a complex path, i.e. `this.foo`, `../foo` etc.
    if (isEligible && !isHelper) {
      var name = sexpr.id.parts[0];

      if (options.knownHelpers[name]) {
        isHelper = true;
      } else if (options.knownHelpersOnly) {
        isEligible = false;
      }
    }

    if (isHelper) { return "helper"; }
    else if (isEligible) { return "ambiguous"; }
    else { return "simple"; }
  },

  pushParams: function(params) {
    for(var i=0, l=params.length; i<l; i++) {
      this.pushParam(params[i]);
    }
  },

  pushParam: function(val) {
    if (this.stringParams) {
      if(val.depth) {
        this.addDepth(val.depth);
      }
      this.opcode('getContext', val.depth || 0);
      this.opcode('pushStringParam', val.stringModeValue, val.type);

      if (val.type === 'sexpr') {
        // Subexpressions get evaluated and passed in
        // in string params mode.
        this.sexpr(val);
      }
    } else {
      if (this.trackIds) {
        this.opcode('pushId', val.type, val.idName || val.stringModeValue);
      }
      this.accept(val);
    }
  },

  setupFullMustacheParams: function(sexpr, program, inverse) {
    var params = sexpr.params;
    this.pushParams(params);

    this.opcode('pushProgram', program);
    this.opcode('pushProgram', inverse);

    if (sexpr.hash) {
      this.hash(sexpr.hash);
    } else {
      this.opcode('emptyHash');
    }

    return params;
  }
};

function precompile(input, options, env) {
  if (input == null || (typeof input !== 'string' && input.constructor !== env.AST.ProgramNode)) {
    throw new Exception("You must pass a string or Handlebars AST to Handlebars.precompile. You passed " + input);
  }

  options = options || {};
  if (!('data' in options)) {
    options.data = true;
  }
  if (options.compat) {
    options.useDepths = true;
  }

  var ast = env.parse(input);
  var environment = new env.Compiler().compile(ast, options);
  return new env.JavaScriptCompiler().compile(environment, options);
}

exports.precompile = precompile;function compile(input, options, env) {
  if (input == null || (typeof input !== 'string' && input.constructor !== env.AST.ProgramNode)) {
    throw new Exception("You must pass a string or Handlebars AST to Handlebars.compile. You passed " + input);
  }

  options = options || {};

  if (!('data' in options)) {
    options.data = true;
  }
  if (options.compat) {
    options.useDepths = true;
  }

  var compiled;

  function compileInput() {
    var ast = env.parse(input);
    var environment = new env.Compiler().compile(ast, options);
    var templateSpec = new env.JavaScriptCompiler().compile(environment, options, undefined, true);
    return env.template(templateSpec);
  }

  // Template is only compiled on first use and cached after that point.
  var ret = function(context, options) {
    if (!compiled) {
      compiled = compileInput();
    }
    return compiled.call(this, context, options);
  };
  ret._setup = function(options) {
    if (!compiled) {
      compiled = compileInput();
    }
    return compiled._setup(options);
  };
  ret._child = function(i, data, depths) {
    if (!compiled) {
      compiled = compileInput();
    }
    return compiled._child(i, data, depths);
  };
  return ret;
}

exports.compile = compile;function argEquals(a, b) {
  if (a === b) {
    return true;
  }

  if (isArray(a) && isArray(b) && a.length === b.length) {
    for (var i = 0; i < a.length; i++) {
      if (!argEquals(a[i], b[i])) {
        return false;
      }
    }
    return true;
  }
}
});
},{"../exception":14,"../utils":17,"async-define":1}],9:[function(require,module,exports){
require('async-define')(["jquery-1.11"],function (__jquery){
"use strict";
var Exception = require("../exception")["default"];

function stripFlags(open, close) {
  return {
    left: open.charAt(2) === '~',
    right: close.charAt(close.length-3) === '~'
  };
}

exports.stripFlags = stripFlags;
function prepareBlock(mustache, program, inverseAndProgram, close, inverted, locInfo) {
  /*jshint -W040 */
  if (mustache.sexpr.id.original !== close.path.original) {
    throw new Exception(mustache.sexpr.id.original + ' doesn\'t match ' + close.path.original, mustache);
  }

  var inverse = inverseAndProgram && inverseAndProgram.program;

  var strip = {
    left: mustache.strip.left,
    right: close.strip.right,

    // Determine the standalone candiacy. Basically flag our content as being possibly standalone
    // so our parent can determine if we actually are standalone
    openStandalone: isNextWhitespace(program.statements),
    closeStandalone: isPrevWhitespace((inverse || program).statements)
  };

  if (mustache.strip.right) {
    omitRight(program.statements, null, true);
  }

  if (inverse) {
    var inverseStrip = inverseAndProgram.strip;

    if (inverseStrip.left) {
      omitLeft(program.statements, null, true);
    }
    if (inverseStrip.right) {
      omitRight(inverse.statements, null, true);
    }
    if (close.strip.left) {
      omitLeft(inverse.statements, null, true);
    }

    // Find standalone else statments
    if (isPrevWhitespace(program.statements)
        && isNextWhitespace(inverse.statements)) {

      omitLeft(program.statements);
      omitRight(inverse.statements);
    }
  } else {
    if (close.strip.left) {
      omitLeft(program.statements, null, true);
    }
  }

  if (inverted) {
    return new this.BlockNode(mustache, inverse, program, strip, locInfo);
  } else {
    return new this.BlockNode(mustache, program, inverse, strip, locInfo);
  }
}

exports.prepareBlock = prepareBlock;
function prepareProgram(statements, isRoot) {
  for (var i = 0, l = statements.length; i < l; i++) {
    var current = statements[i],
        strip = current.strip;

    if (!strip) {
      continue;
    }

    var _isPrevWhitespace = isPrevWhitespace(statements, i, isRoot, current.type === 'partial'),
        _isNextWhitespace = isNextWhitespace(statements, i, isRoot),

        openStandalone = strip.openStandalone && _isPrevWhitespace,
        closeStandalone = strip.closeStandalone && _isNextWhitespace,
        inlineStandalone = strip.inlineStandalone && _isPrevWhitespace && _isNextWhitespace;

    if (strip.right) {
      omitRight(statements, i, true);
    }
    if (strip.left) {
      omitLeft(statements, i, true);
    }

    if (inlineStandalone) {
      omitRight(statements, i);

      if (omitLeft(statements, i)) {
        // If we are on a standalone node, save the indent info for partials
        if (current.type === 'partial') {
          current.indent = (/([ \t]+$)/).exec(statements[i-1].original) ? RegExp.$1 : '';
        }
      }
    }
    if (openStandalone) {
      omitRight((current.program || current.inverse).statements);

      // Strip out the previous content node if it's whitespace only
      omitLeft(statements, i);
    }
    if (closeStandalone) {
      // Always strip the next node
      omitRight(statements, i);

      omitLeft((current.inverse || current.program).statements);
    }
  }

  return statements;
}

exports.prepareProgram = prepareProgram;function isPrevWhitespace(statements, i, isRoot) {
  if (i === undefined) {
    i = statements.length;
  }

  // Nodes that end with newlines are considered whitespace (but are special
  // cased for strip operations)
  var prev = statements[i-1],
      sibling = statements[i-2];
  if (!prev) {
    return isRoot;
  }

  if (prev.type === 'content') {
    return (sibling || !isRoot ? (/\r?\n\s*?$/) : (/(^|\r?\n)\s*?$/)).test(prev.original);
  }
}
function isNextWhitespace(statements, i, isRoot) {
  if (i === undefined) {
    i = -1;
  }

  var next = statements[i+1],
      sibling = statements[i+2];
  if (!next) {
    return isRoot;
  }

  if (next.type === 'content') {
    return (sibling || !isRoot ? (/^\s*?\r?\n/) : (/^\s*?(\r?\n|$)/)).test(next.original);
  }
}

// Marks the node to the right of the position as omitted.
// I.e. {{foo}}' ' will mark the ' ' node as omitted.
//
// If i is undefined, then the first child will be marked as such.
//
// If mulitple is truthy then all whitespace will be stripped out until non-whitespace
// content is met.
function omitRight(statements, i, multiple) {
  var current = statements[i == null ? 0 : i + 1];
  if (!current || current.type !== 'content' || (!multiple && current.rightStripped)) {
    return;
  }

  var original = current.string;
  current.string = current.string.replace(multiple ? (/^\s+/) : (/^[ \t]*\r?\n?/), '');
  current.rightStripped = current.string !== original;
}

// Marks the node to the left of the position as omitted.
// I.e. ' '{{foo}} will mark the ' ' node as omitted.
//
// If i is undefined then the last child will be marked as such.
//
// If mulitple is truthy then all whitespace will be stripped out until non-whitespace
// content is met.
function omitLeft(statements, i, multiple) {
  var current = statements[i == null ? statements.length - 1 : i - 1];
  if (!current || current.type !== 'content' || (!multiple && current.leftStripped)) {
    return;
  }

  // We omit the last node if it's whitespace only and not preceeded by a non-content node.
  var original = current.string;
  current.string = current.string.replace(multiple ? (/\s+$/) : (/[ \t]+$/), '');
  current.leftStripped = current.string !== original;
  return current.leftStripped;
}
});
},{"../exception":14,"async-define":1}],10:[function(require,module,exports){
require('async-define')(["jquery-1.11"],function (__jquery){
"use strict";
var COMPILER_REVISION = require("../base").COMPILER_REVISION;
var REVISION_CHANGES = require("../base").REVISION_CHANGES;
var Exception = require("../exception")["default"];

function Literal(value) {
  this.value = value;
}

function JavaScriptCompiler() {}

JavaScriptCompiler.prototype = {
  // PUBLIC API: You can override these methods in a subclass to provide
  // alternative compiled forms for name lookup and buffering semantics
  nameLookup: function(parent, name /* , type*/) {
    if (JavaScriptCompiler.isValidJavaScriptVariableName(name)) {
      return parent + "." + name;
    } else {
      return parent + "['" + name + "']";
    }
  },
  depthedLookup: function(name) {
    this.aliases.lookup = 'this.lookup';

    return 'lookup(depths, "' + name + '")';
  },

  compilerInfo: function() {
    var revision = COMPILER_REVISION,
        versions = REVISION_CHANGES[revision];
    return [revision, versions];
  },

  appendToBuffer: function(string) {
    if (this.environment.isSimple) {
      return "return " + string + ";";
    } else {
      return {
        appendToBuffer: true,
        content: string,
        toString: function() { return "buffer += " + string + ";"; }
      };
    }
  },

  initializeBuffer: function() {
    return this.quotedString("");
  },

  namespace: "Handlebars",
  // END PUBLIC API

  compile: function(environment, options, context, asObject) {
    this.environment = environment;
    this.options = options;
    this.stringParams = this.options.stringParams;
    this.trackIds = this.options.trackIds;
    this.precompile = !asObject;

    this.name = this.environment.name;
    this.isChild = !!context;
    this.context = context || {
      programs: [],
      environments: []
    };

    this.preamble();

    this.stackSlot = 0;
    this.stackVars = [];
    this.aliases = {};
    this.registers = { list: [] };
    this.hashes = [];
    this.compileStack = [];
    this.inlineStack = [];

    this.compileChildren(environment, options);

    this.useDepths = this.useDepths || environment.depths.list.length || this.options.compat;

    var opcodes = environment.opcodes,
        opcode,
        i,
        l;

    for (i = 0, l = opcodes.length; i < l; i++) {
      opcode = opcodes[i];

      this[opcode.opcode].apply(this, opcode.args);
    }

    // Flush any trailing content that might be pending.
    this.pushSource('');

    /* istanbul ignore next */
    if (this.stackSlot || this.inlineStack.length || this.compileStack.length) {
      throw new Exception('Compile completed with content left on stack');
    }

    var fn = this.createFunctionContext(asObject);
    if (!this.isChild) {
      var ret = {
        compiler: this.compilerInfo(),
        main: fn
      };
      var programs = this.context.programs;
      for (i = 0, l = programs.length; i < l; i++) {
        if (programs[i]) {
          ret[i] = programs[i];
        }
      }

      if (this.environment.usePartial) {
        ret.usePartial = true;
      }
      if (this.options.data) {
        ret.useData = true;
      }
      if (this.useDepths) {
        ret.useDepths = true;
      }
      if (this.options.compat) {
        ret.compat = true;
      }

      if (!asObject) {
        ret.compiler = JSON.stringify(ret.compiler);
        ret = this.objectLiteral(ret);
      }

      return ret;
    } else {
      return fn;
    }
  },

  preamble: function() {
    // track the last context pushed into place to allow skipping the
    // getContext opcode when it would be a noop
    this.lastContext = 0;
    this.source = [];
  },

  createFunctionContext: function(asObject) {
    var varDeclarations = '';

    var locals = this.stackVars.concat(this.registers.list);
    if(locals.length > 0) {
      varDeclarations += ", " + locals.join(", ");
    }

    // Generate minimizer alias mappings
    for (var alias in this.aliases) {
      if (this.aliases.hasOwnProperty(alias)) {
        varDeclarations += ', ' + alias + '=' + this.aliases[alias];
      }
    }

    var params = ["depth0", "helpers", "partials", "data"];

    if (this.useDepths) {
      params.push('depths');
    }

    // Perform a second pass over the output to merge content when possible
    var source = this.mergeSource(varDeclarations);

    if (asObject) {
      params.push(source);

      return Function.apply(this, params);
    } else {
      return 'function(' + params.join(',') + ') {\n  ' + source + '}';
    }
  },
  mergeSource: function(varDeclarations) {
    var source = '',
        buffer,
        appendOnly = !this.forceBuffer,
        appendFirst;

    for (var i = 0, len = this.source.length; i < len; i++) {
      var line = this.source[i];
      if (line.appendToBuffer) {
        if (buffer) {
          buffer = buffer + '\n    + ' + line.content;
        } else {
          buffer = line.content;
        }
      } else {
        if (buffer) {
          if (!source) {
            appendFirst = true;
            source = buffer + ';\n  ';
          } else {
            source += 'buffer += ' + buffer + ';\n  ';
          }
          buffer = undefined;
        }
        source += line + '\n  ';

        if (!this.environment.isSimple) {
          appendOnly = false;
        }
      }
    }

    if (appendOnly) {
      if (buffer || !source) {
        source += 'return ' + (buffer || '""') + ';\n';
      }
    } else {
      varDeclarations += ", buffer = " + (appendFirst ? '' : this.initializeBuffer());
      if (buffer) {
        source += 'return buffer + ' + buffer + ';\n';
      } else {
        source += 'return buffer;\n';
      }
    }

    if (varDeclarations) {
      source = 'var ' + varDeclarations.substring(2) + (appendFirst ? '' : ';\n  ') + source;
    }

    return source;
  },

  // [blockValue]
  //
  // On stack, before: hash, inverse, program, value
  // On stack, after: return value of blockHelperMissing
  //
  // The purpose of this opcode is to take a block of the form
  // `{{#this.foo}}...{{/this.foo}}`, resolve the value of `foo`, and
  // replace it on the stack with the result of properly
  // invoking blockHelperMissing.
  blockValue: function(name) {
    this.aliases.blockHelperMissing = 'helpers.blockHelperMissing';

    var params = [this.contextName(0)];
    this.setupParams(name, 0, params);

    var blockName = this.popStack();
    params.splice(1, 0, blockName);

    this.push('blockHelperMissing.call(' + params.join(', ') + ')');
  },

  // [ambiguousBlockValue]
  //
  // On stack, before: hash, inverse, program, value
  // Compiler value, before: lastHelper=value of last found helper, if any
  // On stack, after, if no lastHelper: same as [blockValue]
  // On stack, after, if lastHelper: value
  ambiguousBlockValue: function() {
    this.aliases.blockHelperMissing = 'helpers.blockHelperMissing';

    // We're being a bit cheeky and reusing the options value from the prior exec
    var params = [this.contextName(0)];
    this.setupParams('', 0, params, true);

    this.flushInline();

    var current = this.topStack();
    params.splice(1, 0, current);

    this.pushSource("if (!" + this.lastHelper + ") { " + current + " = blockHelperMissing.call(" + params.join(", ") + "); }");
  },

  // [appendContent]
  //
  // On stack, before: ...
  // On stack, after: ...
  //
  // Appends the string value of `content` to the current buffer
  appendContent: function(content) {
    if (this.pendingContent) {
      content = this.pendingContent + content;
    }

    this.pendingContent = content;
  },

  // [append]
  //
  // On stack, before: value, ...
  // On stack, after: ...
  //
  // Coerces `value` to a String and appends it to the current buffer.
  //
  // If `value` is truthy, or 0, it is coerced into a string and appended
  // Otherwise, the empty string is appended
  append: function() {
    // Force anything that is inlined onto the stack so we don't have duplication
    // when we examine local
    this.flushInline();
    var local = this.popStack();
    this.pushSource('if (' + local + ' != null) { ' + this.appendToBuffer(local) + ' }');
    if (this.environment.isSimple) {
      this.pushSource("else { " + this.appendToBuffer("''") + " }");
    }
  },

  // [appendEscaped]
  //
  // On stack, before: value, ...
  // On stack, after: ...
  //
  // Escape `value` and append it to the buffer
  appendEscaped: function() {
    this.aliases.escapeExpression = 'this.escapeExpression';

    this.pushSource(this.appendToBuffer("escapeExpression(" + this.popStack() + ")"));
  },

  // [getContext]
  //
  // On stack, before: ...
  // On stack, after: ...
  // Compiler value, after: lastContext=depth
  //
  // Set the value of the `lastContext` compiler value to the depth
  getContext: function(depth) {
    this.lastContext = depth;
  },

  // [pushContext]
  //
  // On stack, before: ...
  // On stack, after: currentContext, ...
  //
  // Pushes the value of the current context onto the stack.
  pushContext: function() {
    this.pushStackLiteral(this.contextName(this.lastContext));
  },

  // [lookupOnContext]
  //
  // On stack, before: ...
  // On stack, after: currentContext[name], ...
  //
  // Looks up the value of `name` on the current context and pushes
  // it onto the stack.
  lookupOnContext: function(parts, falsy, scoped) {
    /*jshint -W083 */
    var i = 0,
        len = parts.length;

    if (!scoped && this.options.compat && !this.lastContext) {
      // The depthed query is expected to handle the undefined logic for the root level that
      // is implemented below, so we evaluate that directly in compat mode
      this.push(this.depthedLookup(parts[i++]));
    } else {
      this.pushContext();
    }

    for (; i < len; i++) {
      this.replaceStack(function(current) {
        var lookup = this.nameLookup(current, parts[i], 'context');
        // We want to ensure that zero and false are handled properly if the context (falsy flag)
        // needs to have the special handling for these values.
        if (!falsy) {
          return ' != null ? ' + lookup + ' : ' + current;
        } else {
          // Otherwise we can use generic falsy handling
          return ' && ' + lookup;
        }
      });
    }
  },

  // [lookupData]
  //
  // On stack, before: ...
  // On stack, after: data, ...
  //
  // Push the data lookup operator
  lookupData: function(depth, parts) {
    /*jshint -W083 */
    if (!depth) {
      this.pushStackLiteral('data');
    } else {
      this.pushStackLiteral('this.data(data, ' + depth + ')');
    }

    var len = parts.length;
    for (var i = 0; i < len; i++) {
      this.replaceStack(function(current) {
        return ' && ' + this.nameLookup(current, parts[i], 'data');
      });
    }
  },

  // [resolvePossibleLambda]
  //
  // On stack, before: value, ...
  // On stack, after: resolved value, ...
  //
  // If the `value` is a lambda, replace it on the stack by
  // the return value of the lambda
  resolvePossibleLambda: function() {
    this.aliases.lambda = 'this.lambda';

    this.push('lambda(' + this.popStack() + ', ' + this.contextName(0) + ')');
  },

  // [pushStringParam]
  //
  // On stack, before: ...
  // On stack, after: string, currentContext, ...
  //
  // This opcode is designed for use in string mode, which
  // provides the string value of a parameter along with its
  // depth rather than resolving it immediately.
  pushStringParam: function(string, type) {
    this.pushContext();
    this.pushString(type);

    // If it's a subexpression, the string result
    // will be pushed after this opcode.
    if (type !== 'sexpr') {
      if (typeof string === 'string') {
        this.pushString(string);
      } else {
        this.pushStackLiteral(string);
      }
    }
  },

  emptyHash: function() {
    this.pushStackLiteral('{}');

    if (this.trackIds) {
      this.push('{}'); // hashIds
    }
    if (this.stringParams) {
      this.push('{}'); // hashContexts
      this.push('{}'); // hashTypes
    }
  },
  pushHash: function() {
    if (this.hash) {
      this.hashes.push(this.hash);
    }
    this.hash = {values: [], types: [], contexts: [], ids: []};
  },
  popHash: function() {
    var hash = this.hash;
    this.hash = this.hashes.pop();

    if (this.trackIds) {
      this.push('{' + hash.ids.join(',') + '}');
    }
    if (this.stringParams) {
      this.push('{' + hash.contexts.join(',') + '}');
      this.push('{' + hash.types.join(',') + '}');
    }

    this.push('{\n    ' + hash.values.join(',\n    ') + '\n  }');
  },

  // [pushString]
  //
  // On stack, before: ...
  // On stack, after: quotedString(string), ...
  //
  // Push a quoted version of `string` onto the stack
  pushString: function(string) {
    this.pushStackLiteral(this.quotedString(string));
  },

  // [push]
  //
  // On stack, before: ...
  // On stack, after: expr, ...
  //
  // Push an expression onto the stack
  push: function(expr) {
    this.inlineStack.push(expr);
    return expr;
  },

  // [pushLiteral]
  //
  // On stack, before: ...
  // On stack, after: value, ...
  //
  // Pushes a value onto the stack. This operation prevents
  // the compiler from creating a temporary variable to hold
  // it.
  pushLiteral: function(value) {
    this.pushStackLiteral(value);
  },

  // [pushProgram]
  //
  // On stack, before: ...
  // On stack, after: program(guid), ...
  //
  // Push a program expression onto the stack. This takes
  // a compile-time guid and converts it into a runtime-accessible
  // expression.
  pushProgram: function(guid) {
    if (guid != null) {
      this.pushStackLiteral(this.programExpression(guid));
    } else {
      this.pushStackLiteral(null);
    }
  },

  // [invokeHelper]
  //
  // On stack, before: hash, inverse, program, params..., ...
  // On stack, after: result of helper invocation
  //
  // Pops off the helper's parameters, invokes the helper,
  // and pushes the helper's return value onto the stack.
  //
  // If the helper is not found, `helperMissing` is called.
  invokeHelper: function(paramSize, name, isSimple) {
    this.aliases.helperMissing = 'helpers.helperMissing';

    var nonHelper = this.popStack();
    var helper = this.setupHelper(paramSize, name);

    var lookup = (isSimple ? helper.name + ' || ' : '') + nonHelper + ' || helperMissing';
    this.push('((' + lookup + ').call(' + helper.callParams + '))');
  },

  // [invokeKnownHelper]
  //
  // On stack, before: hash, inverse, program, params..., ...
  // On stack, after: result of helper invocation
  //
  // This operation is used when the helper is known to exist,
  // so a `helperMissing` fallback is not required.
  invokeKnownHelper: function(paramSize, name) {
    var helper = this.setupHelper(paramSize, name);
    this.push(helper.name + ".call(" + helper.callParams + ")");
  },

  // [invokeAmbiguous]
  //
  // On stack, before: hash, inverse, program, params..., ...
  // On stack, after: result of disambiguation
  //
  // This operation is used when an expression like `{{foo}}`
  // is provided, but we don't know at compile-time whether it
  // is a helper or a path.
  //
  // This operation emits more code than the other options,
  // and can be avoided by passing the `knownHelpers` and
  // `knownHelpersOnly` flags at compile-time.
  invokeAmbiguous: function(name, helperCall) {
    this.aliases.functionType = '"function"';
    this.aliases.helperMissing = 'helpers.helperMissing';
    this.useRegister('helper');

    var nonHelper = this.popStack();

    this.emptyHash();
    var helper = this.setupHelper(0, name, helperCall);

    var helperName = this.lastHelper = this.nameLookup('helpers', name, 'helper');

    this.push(
      '((helper = (helper = ' + helperName + ' || ' + nonHelper + ') != null ? helper : helperMissing'
        + (helper.paramsInit ? '),(' + helper.paramsInit : '') + '),'
      + '(typeof helper === functionType ? helper.call(' + helper.callParams + ') : helper))');
  },

  // [invokePartial]
  //
  // On stack, before: context, ...
  // On stack after: result of partial invocation
  //
  // This operation pops off a context, invokes a partial with that context,
  // and pushes the result of the invocation back.
  invokePartial: function(name, indent) {
    var params = [this.nameLookup('partials', name, 'partial'), "'" + indent + "'", "'" + name + "'", this.popStack(), this.popStack(), "helpers", "partials"];

    if (this.options.data) {
      params.push("data");
    } else if (this.options.compat) {
      params.push('undefined');
    }
    if (this.options.compat) {
      params.push('depths');
    }

    this.push("this.invokePartial(" + params.join(", ") + ")");
  },

  // [assignToHash]
  //
  // On stack, before: value, ..., hash, ...
  // On stack, after: ..., hash, ...
  //
  // Pops a value off the stack and assigns it to the current hash
  assignToHash: function(key) {
    var value = this.popStack(),
        context,
        type,
        id;

    if (this.trackIds) {
      id = this.popStack();
    }
    if (this.stringParams) {
      type = this.popStack();
      context = this.popStack();
    }

    var hash = this.hash;
    if (context) {
      hash.contexts.push("'" + key + "': " + context);
    }
    if (type) {
      hash.types.push("'" + key + "': " + type);
    }
    if (id) {
      hash.ids.push("'" + key + "': " + id);
    }
    hash.values.push("'" + key + "': (" + value + ")");
  },

  pushId: function(type, name) {
    if (type === 'ID' || type === 'DATA') {
      this.pushString(name);
    } else if (type === 'sexpr') {
      this.pushStackLiteral('true');
    } else {
      this.pushStackLiteral('null');
    }
  },

  // HELPERS

  compiler: JavaScriptCompiler,

  compileChildren: function(environment, options) {
    var children = environment.children, child, compiler;

    for(var i=0, l=children.length; i<l; i++) {
      child = children[i];
      compiler = new this.compiler();

      var index = this.matchExistingProgram(child);

      if (index == null) {
        this.context.programs.push('');     // Placeholder to prevent name conflicts for nested children
        index = this.context.programs.length;
        child.index = index;
        child.name = 'program' + index;
        this.context.programs[index] = compiler.compile(child, options, this.context, !this.precompile);
        this.context.environments[index] = child;

        this.useDepths = this.useDepths || compiler.useDepths;
      } else {
        child.index = index;
        child.name = 'program' + index;
      }
    }
  },
  matchExistingProgram: function(child) {
    for (var i = 0, len = this.context.environments.length; i < len; i++) {
      var environment = this.context.environments[i];
      if (environment && environment.equals(child)) {
        return i;
      }
    }
  },

  programExpression: function(guid) {
    var child = this.environment.children[guid],
        depths = child.depths.list,
        useDepths = this.useDepths,
        depth;

    var programParams = [child.index, 'data'];

    if (useDepths) {
      programParams.push('depths');
    }

    return 'this.program(' + programParams.join(', ') + ')';
  },

  useRegister: function(name) {
    if(!this.registers[name]) {
      this.registers[name] = true;
      this.registers.list.push(name);
    }
  },

  pushStackLiteral: function(item) {
    return this.push(new Literal(item));
  },

  pushSource: function(source) {
    if (this.pendingContent) {
      this.source.push(this.appendToBuffer(this.quotedString(this.pendingContent)));
      this.pendingContent = undefined;
    }

    if (source) {
      this.source.push(source);
    }
  },

  pushStack: function(item) {
    this.flushInline();

    var stack = this.incrStack();
    this.pushSource(stack + " = " + item + ";");
    this.compileStack.push(stack);
    return stack;
  },

  replaceStack: function(callback) {
    var prefix = '',
        inline = this.isInline(),
        stack,
        createdStack,
        usedLiteral;

    /* istanbul ignore next */
    if (!this.isInline()) {
      throw new Exception('replaceStack on non-inline');
    }

    // We want to merge the inline statement into the replacement statement via ','
    var top = this.popStack(true);

    if (top instanceof Literal) {
      // Literals do not need to be inlined
      prefix = stack = top.value;
      usedLiteral = true;
    } else {
      // Get or create the current stack name for use by the inline
      createdStack = !this.stackSlot;
      var name = !createdStack ? this.topStackName() : this.incrStack();

      prefix = '(' + this.push(name) + ' = ' + top + ')';
      stack = this.topStack();
    }

    var item = callback.call(this, stack);

    if (!usedLiteral) {
      this.popStack();
    }
    if (createdStack) {
      this.stackSlot--;
    }
    this.push('(' + prefix + item + ')');
  },

  incrStack: function() {
    this.stackSlot++;
    if(this.stackSlot > this.stackVars.length) { this.stackVars.push("stack" + this.stackSlot); }
    return this.topStackName();
  },
  topStackName: function() {
    return "stack" + this.stackSlot;
  },
  flushInline: function() {
    var inlineStack = this.inlineStack;
    if (inlineStack.length) {
      this.inlineStack = [];
      for (var i = 0, len = inlineStack.length; i < len; i++) {
        var entry = inlineStack[i];
        if (entry instanceof Literal) {
          this.compileStack.push(entry);
        } else {
          this.pushStack(entry);
        }
      }
    }
  },
  isInline: function() {
    return this.inlineStack.length;
  },

  popStack: function(wrapped) {
    var inline = this.isInline(),
        item = (inline ? this.inlineStack : this.compileStack).pop();

    if (!wrapped && (item instanceof Literal)) {
      return item.value;
    } else {
      if (!inline) {
        /* istanbul ignore next */
        if (!this.stackSlot) {
          throw new Exception('Invalid stack pop');
        }
        this.stackSlot--;
      }
      return item;
    }
  },

  topStack: function() {
    var stack = (this.isInline() ? this.inlineStack : this.compileStack),
        item = stack[stack.length - 1];

    if (item instanceof Literal) {
      return item.value;
    } else {
      return item;
    }
  },

  contextName: function(context) {
    if (this.useDepths && context) {
      return 'depths[' + context + ']';
    } else {
      return 'depth' + context;
    }
  },

  quotedString: function(str) {
    return '"' + str
      .replace(/\\/g, '\\\\')
      .replace(/"/g, '\\"')
      .replace(/\n/g, '\\n')
      .replace(/\r/g, '\\r')
      .replace(/\u2028/g, '\\u2028')   // Per Ecma-262 7.3 + 7.8.4
      .replace(/\u2029/g, '\\u2029') + '"';
  },

  objectLiteral: function(obj) {
    var pairs = [];

    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        pairs.push(this.quotedString(key) + ':' + obj[key]);
      }
    }

    return '{' + pairs.join(',') + '}';
  },

  setupHelper: function(paramSize, name, blockHelper) {
    var params = [],
        paramsInit = this.setupParams(name, paramSize, params, blockHelper);
    var foundHelper = this.nameLookup('helpers', name, 'helper');

    return {
      params: params,
      paramsInit: paramsInit,
      name: foundHelper,
      callParams: [this.contextName(0)].concat(params).join(", ")
    };
  },

  setupOptions: function(helper, paramSize, params) {
    var options = {}, contexts = [], types = [], ids = [], param, inverse, program;

    options.name = this.quotedString(helper);
    options.hash = this.popStack();

    if (this.trackIds) {
      options.hashIds = this.popStack();
    }
    if (this.stringParams) {
      options.hashTypes = this.popStack();
      options.hashContexts = this.popStack();
    }

    inverse = this.popStack();
    program = this.popStack();

    // Avoid setting fn and inverse if neither are set. This allows
    // helpers to do a check for `if (options.fn)`
    if (program || inverse) {
      if (!program) {
        program = 'this.noop';
      }

      if (!inverse) {
        inverse = 'this.noop';
      }

      options.fn = program;
      options.inverse = inverse;
    }

    // The parameters go on to the stack in order (making sure that they are evaluated in order)
    // so we need to pop them off the stack in reverse order
    var i = paramSize;
    while (i--) {
      param = this.popStack();
      params[i] = param;

      if (this.trackIds) {
        ids[i] = this.popStack();
      }
      if (this.stringParams) {
        types[i] = this.popStack();
        contexts[i] = this.popStack();
      }
    }

    if (this.trackIds) {
      options.ids = "[" + ids.join(",") + "]";
    }
    if (this.stringParams) {
      options.types = "[" + types.join(",") + "]";
      options.contexts = "[" + contexts.join(",") + "]";
    }

    if (this.options.data) {
      options.data = "data";
    }

    return options;
  },

  // the params and contexts arguments are passed in arrays
  // to fill in
  setupParams: function(helperName, paramSize, params, useRegister) {
    var options = this.objectLiteral(this.setupOptions(helperName, paramSize, params));

    if (useRegister) {
      this.useRegister('options');
      params.push('options');
      return 'options=' + options;
    } else {
      params.push(options);
      return '';
    }
  }
};

var reservedWords = (
  "break else new var" +
  " case finally return void" +
  " catch for switch while" +
  " continue function this with" +
  " default if throw" +
  " delete in try" +
  " do instanceof typeof" +
  " abstract enum int short" +
  " boolean export interface static" +
  " byte extends long super" +
  " char final native synchronized" +
  " class float package throws" +
  " const goto private transient" +
  " debugger implements protected volatile" +
  " double import public let yield"
).split(" ");

var compilerWords = JavaScriptCompiler.RESERVED_WORDS = {};

for(var i=0, l=reservedWords.length; i<l; i++) {
  compilerWords[reservedWords[i]] = true;
}

JavaScriptCompiler.isValidJavaScriptVariableName = function(name) {
  return !JavaScriptCompiler.RESERVED_WORDS[name] && /^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(name);
};

exports["default"] = JavaScriptCompiler;
});
},{"../base":5,"../exception":14,"async-define":1}],11:[function(require,module,exports){
require('async-define')(["jquery-1.11"],function (__jquery){
"use strict";
/* jshint ignore:start */
/* istanbul ignore next */
/* Jison generated parser */
var handlebars = (function(){
var parser = {trace: function trace() { },
yy: {},
symbols_: {"error":2,"root":3,"program":4,"EOF":5,"program_repetition0":6,"statement":7,"mustache":8,"block":9,"rawBlock":10,"partial":11,"CONTENT":12,"COMMENT":13,"openRawBlock":14,"END_RAW_BLOCK":15,"OPEN_RAW_BLOCK":16,"sexpr":17,"CLOSE_RAW_BLOCK":18,"openBlock":19,"block_option0":20,"closeBlock":21,"openInverse":22,"block_option1":23,"OPEN_BLOCK":24,"CLOSE":25,"OPEN_INVERSE":26,"inverseAndProgram":27,"INVERSE":28,"OPEN_ENDBLOCK":29,"path":30,"OPEN":31,"OPEN_UNESCAPED":32,"CLOSE_UNESCAPED":33,"OPEN_PARTIAL":34,"partialName":35,"param":36,"partial_option0":37,"partial_option1":38,"sexpr_repetition0":39,"sexpr_option0":40,"dataName":41,"STRING":42,"NUMBER":43,"BOOLEAN":44,"OPEN_SEXPR":45,"CLOSE_SEXPR":46,"hash":47,"hash_repetition_plus0":48,"hashSegment":49,"ID":50,"EQUALS":51,"DATA":52,"pathSegments":53,"SEP":54,"$accept":0,"$end":1},
terminals_: {2:"error",5:"EOF",12:"CONTENT",13:"COMMENT",15:"END_RAW_BLOCK",16:"OPEN_RAW_BLOCK",18:"CLOSE_RAW_BLOCK",24:"OPEN_BLOCK",25:"CLOSE",26:"OPEN_INVERSE",28:"INVERSE",29:"OPEN_ENDBLOCK",31:"OPEN",32:"OPEN_UNESCAPED",33:"CLOSE_UNESCAPED",34:"OPEN_PARTIAL",42:"STRING",43:"NUMBER",44:"BOOLEAN",45:"OPEN_SEXPR",46:"CLOSE_SEXPR",50:"ID",51:"EQUALS",52:"DATA",54:"SEP"},
productions_: [0,[3,2],[4,1],[7,1],[7,1],[7,1],[7,1],[7,1],[7,1],[10,3],[14,3],[9,4],[9,4],[19,3],[22,3],[27,2],[21,3],[8,3],[8,3],[11,5],[11,4],[17,3],[17,1],[36,1],[36,1],[36,1],[36,1],[36,1],[36,3],[47,1],[49,3],[35,1],[35,1],[35,1],[41,2],[30,1],[53,3],[53,1],[6,0],[6,2],[20,0],[20,1],[23,0],[23,1],[37,0],[37,1],[38,0],[38,1],[39,0],[39,2],[40,0],[40,1],[48,1],[48,2]],
performAction: function anonymous(yytext,yyleng,yylineno,yy,yystate,$$,_$) {

var $0 = $$.length - 1;
switch (yystate) {
case 1: yy.prepareProgram($$[$0-1].statements, true); return $$[$0-1]; 
break;
case 2:this.$ = new yy.ProgramNode(yy.prepareProgram($$[$0]), {}, this._$);
break;
case 3:this.$ = $$[$0];
break;
case 4:this.$ = $$[$0];
break;
case 5:this.$ = $$[$0];
break;
case 6:this.$ = $$[$0];
break;
case 7:this.$ = new yy.ContentNode($$[$0], this._$);
break;
case 8:this.$ = new yy.CommentNode($$[$0], this._$);
break;
case 9:this.$ = new yy.RawBlockNode($$[$0-2], $$[$0-1], $$[$0], this._$);
break;
case 10:this.$ = new yy.MustacheNode($$[$0-1], null, '', '', this._$);
break;
case 11:this.$ = yy.prepareBlock($$[$0-3], $$[$0-2], $$[$0-1], $$[$0], false, this._$);
break;
case 12:this.$ = yy.prepareBlock($$[$0-3], $$[$0-2], $$[$0-1], $$[$0], true, this._$);
break;
case 13:this.$ = new yy.MustacheNode($$[$0-1], null, $$[$0-2], yy.stripFlags($$[$0-2], $$[$0]), this._$);
break;
case 14:this.$ = new yy.MustacheNode($$[$0-1], null, $$[$0-2], yy.stripFlags($$[$0-2], $$[$0]), this._$);
break;
case 15:this.$ = { strip: yy.stripFlags($$[$0-1], $$[$0-1]), program: $$[$0] };
break;
case 16:this.$ = {path: $$[$0-1], strip: yy.stripFlags($$[$0-2], $$[$0])};
break;
case 17:this.$ = new yy.MustacheNode($$[$0-1], null, $$[$0-2], yy.stripFlags($$[$0-2], $$[$0]), this._$);
break;
case 18:this.$ = new yy.MustacheNode($$[$0-1], null, $$[$0-2], yy.stripFlags($$[$0-2], $$[$0]), this._$);
break;
case 19:this.$ = new yy.PartialNode($$[$0-3], $$[$0-2], $$[$0-1], yy.stripFlags($$[$0-4], $$[$0]), this._$);
break;
case 20:this.$ = new yy.PartialNode($$[$0-2], undefined, $$[$0-1], yy.stripFlags($$[$0-3], $$[$0]), this._$);
break;
case 21:this.$ = new yy.SexprNode([$$[$0-2]].concat($$[$0-1]), $$[$0], this._$);
break;
case 22:this.$ = new yy.SexprNode([$$[$0]], null, this._$);
break;
case 23:this.$ = $$[$0];
break;
case 24:this.$ = new yy.StringNode($$[$0], this._$);
break;
case 25:this.$ = new yy.NumberNode($$[$0], this._$);
break;
case 26:this.$ = new yy.BooleanNode($$[$0], this._$);
break;
case 27:this.$ = $$[$0];
break;
case 28:$$[$0-1].isHelper = true; this.$ = $$[$0-1];
break;
case 29:this.$ = new yy.HashNode($$[$0], this._$);
break;
case 30:this.$ = [$$[$0-2], $$[$0]];
break;
case 31:this.$ = new yy.PartialNameNode($$[$0], this._$);
break;
case 32:this.$ = new yy.PartialNameNode(new yy.StringNode($$[$0], this._$), this._$);
break;
case 33:this.$ = new yy.PartialNameNode(new yy.NumberNode($$[$0], this._$));
break;
case 34:this.$ = new yy.DataNode($$[$0], this._$);
break;
case 35:this.$ = new yy.IdNode($$[$0], this._$);
break;
case 36: $$[$0-2].push({part: $$[$0], separator: $$[$0-1]}); this.$ = $$[$0-2]; 
break;
case 37:this.$ = [{part: $$[$0]}];
break;
case 38:this.$ = [];
break;
case 39:$$[$0-1].push($$[$0]);
break;
case 48:this.$ = [];
break;
case 49:$$[$0-1].push($$[$0]);
break;
case 52:this.$ = [$$[$0]];
break;
case 53:$$[$0-1].push($$[$0]);
break;
}
},
table: [{3:1,4:2,5:[2,38],6:3,12:[2,38],13:[2,38],16:[2,38],24:[2,38],26:[2,38],31:[2,38],32:[2,38],34:[2,38]},{1:[3]},{5:[1,4]},{5:[2,2],7:5,8:6,9:7,10:8,11:9,12:[1,10],13:[1,11],14:16,16:[1,20],19:14,22:15,24:[1,18],26:[1,19],28:[2,2],29:[2,2],31:[1,12],32:[1,13],34:[1,17]},{1:[2,1]},{5:[2,39],12:[2,39],13:[2,39],16:[2,39],24:[2,39],26:[2,39],28:[2,39],29:[2,39],31:[2,39],32:[2,39],34:[2,39]},{5:[2,3],12:[2,3],13:[2,3],16:[2,3],24:[2,3],26:[2,3],28:[2,3],29:[2,3],31:[2,3],32:[2,3],34:[2,3]},{5:[2,4],12:[2,4],13:[2,4],16:[2,4],24:[2,4],26:[2,4],28:[2,4],29:[2,4],31:[2,4],32:[2,4],34:[2,4]},{5:[2,5],12:[2,5],13:[2,5],16:[2,5],24:[2,5],26:[2,5],28:[2,5],29:[2,5],31:[2,5],32:[2,5],34:[2,5]},{5:[2,6],12:[2,6],13:[2,6],16:[2,6],24:[2,6],26:[2,6],28:[2,6],29:[2,6],31:[2,6],32:[2,6],34:[2,6]},{5:[2,7],12:[2,7],13:[2,7],16:[2,7],24:[2,7],26:[2,7],28:[2,7],29:[2,7],31:[2,7],32:[2,7],34:[2,7]},{5:[2,8],12:[2,8],13:[2,8],16:[2,8],24:[2,8],26:[2,8],28:[2,8],29:[2,8],31:[2,8],32:[2,8],34:[2,8]},{17:21,30:22,41:23,50:[1,26],52:[1,25],53:24},{17:27,30:22,41:23,50:[1,26],52:[1,25],53:24},{4:28,6:3,12:[2,38],13:[2,38],16:[2,38],24:[2,38],26:[2,38],28:[2,38],29:[2,38],31:[2,38],32:[2,38],34:[2,38]},{4:29,6:3,12:[2,38],13:[2,38],16:[2,38],24:[2,38],26:[2,38],28:[2,38],29:[2,38],31:[2,38],32:[2,38],34:[2,38]},{12:[1,30]},{30:32,35:31,42:[1,33],43:[1,34],50:[1,26],53:24},{17:35,30:22,41:23,50:[1,26],52:[1,25],53:24},{17:36,30:22,41:23,50:[1,26],52:[1,25],53:24},{17:37,30:22,41:23,50:[1,26],52:[1,25],53:24},{25:[1,38]},{18:[2,48],25:[2,48],33:[2,48],39:39,42:[2,48],43:[2,48],44:[2,48],45:[2,48],46:[2,48],50:[2,48],52:[2,48]},{18:[2,22],25:[2,22],33:[2,22],46:[2,22]},{18:[2,35],25:[2,35],33:[2,35],42:[2,35],43:[2,35],44:[2,35],45:[2,35],46:[2,35],50:[2,35],52:[2,35],54:[1,40]},{30:41,50:[1,26],53:24},{18:[2,37],25:[2,37],33:[2,37],42:[2,37],43:[2,37],44:[2,37],45:[2,37],46:[2,37],50:[2,37],52:[2,37],54:[2,37]},{33:[1,42]},{20:43,27:44,28:[1,45],29:[2,40]},{23:46,27:47,28:[1,45],29:[2,42]},{15:[1,48]},{25:[2,46],30:51,36:49,38:50,41:55,42:[1,52],43:[1,53],44:[1,54],45:[1,56],47:57,48:58,49:60,50:[1,59],52:[1,25],53:24},{25:[2,31],42:[2,31],43:[2,31],44:[2,31],45:[2,31],50:[2,31],52:[2,31]},{25:[2,32],42:[2,32],43:[2,32],44:[2,32],45:[2,32],50:[2,32],52:[2,32]},{25:[2,33],42:[2,33],43:[2,33],44:[2,33],45:[2,33],50:[2,33],52:[2,33]},{25:[1,61]},{25:[1,62]},{18:[1,63]},{5:[2,17],12:[2,17],13:[2,17],16:[2,17],24:[2,17],26:[2,17],28:[2,17],29:[2,17],31:[2,17],32:[2,17],34:[2,17]},{18:[2,50],25:[2,50],30:51,33:[2,50],36:65,40:64,41:55,42:[1,52],43:[1,53],44:[1,54],45:[1,56],46:[2,50],47:66,48:58,49:60,50:[1,59],52:[1,25],53:24},{50:[1,67]},{18:[2,34],25:[2,34],33:[2,34],42:[2,34],43:[2,34],44:[2,34],45:[2,34],46:[2,34],50:[2,34],52:[2,34]},{5:[2,18],12:[2,18],13:[2,18],16:[2,18],24:[2,18],26:[2,18],28:[2,18],29:[2,18],31:[2,18],32:[2,18],34:[2,18]},{21:68,29:[1,69]},{29:[2,41]},{4:70,6:3,12:[2,38],13:[2,38],16:[2,38],24:[2,38],26:[2,38],29:[2,38],31:[2,38],32:[2,38],34:[2,38]},{21:71,29:[1,69]},{29:[2,43]},{5:[2,9],12:[2,9],13:[2,9],16:[2,9],24:[2,9],26:[2,9],28:[2,9],29:[2,9],31:[2,9],32:[2,9],34:[2,9]},{25:[2,44],37:72,47:73,48:58,49:60,50:[1,74]},{25:[1,75]},{18:[2,23],25:[2,23],33:[2,23],42:[2,23],43:[2,23],44:[2,23],45:[2,23],46:[2,23],50:[2,23],52:[2,23]},{18:[2,24],25:[2,24],33:[2,24],42:[2,24],43:[2,24],44:[2,24],45:[2,24],46:[2,24],50:[2,24],52:[2,24]},{18:[2,25],25:[2,25],33:[2,25],42:[2,25],43:[2,25],44:[2,25],45:[2,25],46:[2,25],50:[2,25],52:[2,25]},{18:[2,26],25:[2,26],33:[2,26],42:[2,26],43:[2,26],44:[2,26],45:[2,26],46:[2,26],50:[2,26],52:[2,26]},{18:[2,27],25:[2,27],33:[2,27],42:[2,27],43:[2,27],44:[2,27],45:[2,27],46:[2,27],50:[2,27],52:[2,27]},{17:76,30:22,41:23,50:[1,26],52:[1,25],53:24},{25:[2,47]},{18:[2,29],25:[2,29],33:[2,29],46:[2,29],49:77,50:[1,74]},{18:[2,37],25:[2,37],33:[2,37],42:[2,37],43:[2,37],44:[2,37],45:[2,37],46:[2,37],50:[2,37],51:[1,78],52:[2,37],54:[2,37]},{18:[2,52],25:[2,52],33:[2,52],46:[2,52],50:[2,52]},{12:[2,13],13:[2,13],16:[2,13],24:[2,13],26:[2,13],28:[2,13],29:[2,13],31:[2,13],32:[2,13],34:[2,13]},{12:[2,14],13:[2,14],16:[2,14],24:[2,14],26:[2,14],28:[2,14],29:[2,14],31:[2,14],32:[2,14],34:[2,14]},{12:[2,10]},{18:[2,21],25:[2,21],33:[2,21],46:[2,21]},{18:[2,49],25:[2,49],33:[2,49],42:[2,49],43:[2,49],44:[2,49],45:[2,49],46:[2,49],50:[2,49],52:[2,49]},{18:[2,51],25:[2,51],33:[2,51],46:[2,51]},{18:[2,36],25:[2,36],33:[2,36],42:[2,36],43:[2,36],44:[2,36],45:[2,36],46:[2,36],50:[2,36],52:[2,36],54:[2,36]},{5:[2,11],12:[2,11],13:[2,11],16:[2,11],24:[2,11],26:[2,11],28:[2,11],29:[2,11],31:[2,11],32:[2,11],34:[2,11]},{30:79,50:[1,26],53:24},{29:[2,15]},{5:[2,12],12:[2,12],13:[2,12],16:[2,12],24:[2,12],26:[2,12],28:[2,12],29:[2,12],31:[2,12],32:[2,12],34:[2,12]},{25:[1,80]},{25:[2,45]},{51:[1,78]},{5:[2,20],12:[2,20],13:[2,20],16:[2,20],24:[2,20],26:[2,20],28:[2,20],29:[2,20],31:[2,20],32:[2,20],34:[2,20]},{46:[1,81]},{18:[2,53],25:[2,53],33:[2,53],46:[2,53],50:[2,53]},{30:51,36:82,41:55,42:[1,52],43:[1,53],44:[1,54],45:[1,56],50:[1,26],52:[1,25],53:24},{25:[1,83]},{5:[2,19],12:[2,19],13:[2,19],16:[2,19],24:[2,19],26:[2,19],28:[2,19],29:[2,19],31:[2,19],32:[2,19],34:[2,19]},{18:[2,28],25:[2,28],33:[2,28],42:[2,28],43:[2,28],44:[2,28],45:[2,28],46:[2,28],50:[2,28],52:[2,28]},{18:[2,30],25:[2,30],33:[2,30],46:[2,30],50:[2,30]},{5:[2,16],12:[2,16],13:[2,16],16:[2,16],24:[2,16],26:[2,16],28:[2,16],29:[2,16],31:[2,16],32:[2,16],34:[2,16]}],
defaultActions: {4:[2,1],44:[2,41],47:[2,43],57:[2,47],63:[2,10],70:[2,15],73:[2,45]},
parseError: function parseError(str, hash) {
    throw new Error(str);
},
parse: function parse(input) {
    var self = this, stack = [0], vstack = [null], lstack = [], table = this.table, yytext = "", yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
    this.lexer.setInput(input);
    this.lexer.yy = this.yy;
    this.yy.lexer = this.lexer;
    this.yy.parser = this;
    if (typeof this.lexer.yylloc == "undefined")
        this.lexer.yylloc = {};
    var yyloc = this.lexer.yylloc;
    lstack.push(yyloc);
    var ranges = this.lexer.options && this.lexer.options.ranges;
    if (typeof this.yy.parseError === "function")
        this.parseError = this.yy.parseError;
    function popStack(n) {
        stack.length = stack.length - 2 * n;
        vstack.length = vstack.length - n;
        lstack.length = lstack.length - n;
    }
    function lex() {
        var token;
        token = self.lexer.lex() || 1;
        if (typeof token !== "number") {
            token = self.symbols_[token] || token;
        }
        return token;
    }
    var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
    while (true) {
        state = stack[stack.length - 1];
        if (this.defaultActions[state]) {
            action = this.defaultActions[state];
        } else {
            if (symbol === null || typeof symbol == "undefined") {
                symbol = lex();
            }
            action = table[state] && table[state][symbol];
        }
        if (typeof action === "undefined" || !action.length || !action[0]) {
            var errStr = "";
            if (!recovering) {
                expected = [];
                for (p in table[state])
                    if (this.terminals_[p] && p > 2) {
                        expected.push("'" + this.terminals_[p] + "'");
                    }
                if (this.lexer.showPosition) {
                    errStr = "Parse error on line " + (yylineno + 1) + ":\n" + this.lexer.showPosition() + "\nExpecting " + expected.join(", ") + ", got '" + (this.terminals_[symbol] || symbol) + "'";
                } else {
                    errStr = "Parse error on line " + (yylineno + 1) + ": Unexpected " + (symbol == 1?"end of input":"'" + (this.terminals_[symbol] || symbol) + "'");
                }
                this.parseError(errStr, {text: this.lexer.match, token: this.terminals_[symbol] || symbol, line: this.lexer.yylineno, loc: yyloc, expected: expected});
            }
        }
        if (action[0] instanceof Array && action.length > 1) {
            throw new Error("Parse Error: multiple actions possible at state: " + state + ", token: " + symbol);
        }
        switch (action[0]) {
        case 1:
            stack.push(symbol);
            vstack.push(this.lexer.yytext);
            lstack.push(this.lexer.yylloc);
            stack.push(action[1]);
            symbol = null;
            if (!preErrorSymbol) {
                yyleng = this.lexer.yyleng;
                yytext = this.lexer.yytext;
                yylineno = this.lexer.yylineno;
                yyloc = this.lexer.yylloc;
                if (recovering > 0)
                    recovering--;
            } else {
                symbol = preErrorSymbol;
                preErrorSymbol = null;
            }
            break;
        case 2:
            len = this.productions_[action[1]][1];
            yyval.$ = vstack[vstack.length - len];
            yyval._$ = {first_line: lstack[lstack.length - (len || 1)].first_line, last_line: lstack[lstack.length - 1].last_line, first_column: lstack[lstack.length - (len || 1)].first_column, last_column: lstack[lstack.length - 1].last_column};
            if (ranges) {
                yyval._$.range = [lstack[lstack.length - (len || 1)].range[0], lstack[lstack.length - 1].range[1]];
            }
            r = this.performAction.call(yyval, yytext, yyleng, yylineno, this.yy, action[1], vstack, lstack);
            if (typeof r !== "undefined") {
                return r;
            }
            if (len) {
                stack = stack.slice(0, -1 * len * 2);
                vstack = vstack.slice(0, -1 * len);
                lstack = lstack.slice(0, -1 * len);
            }
            stack.push(this.productions_[action[1]][0]);
            vstack.push(yyval.$);
            lstack.push(yyval._$);
            newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
            stack.push(newState);
            break;
        case 3:
            return true;
        }
    }
    return true;
}
};
/* Jison generated lexer */
var lexer = (function(){
var lexer = ({EOF:1,
parseError:function parseError(str, hash) {
        if (this.yy.parser) {
            this.yy.parser.parseError(str, hash);
        } else {
            throw new Error(str);
        }
    },
setInput:function (input) {
        this._input = input;
        this._more = this._less = this.done = false;
        this.yylineno = this.yyleng = 0;
        this.yytext = this.matched = this.match = '';
        this.conditionStack = ['INITIAL'];
        this.yylloc = {first_line:1,first_column:0,last_line:1,last_column:0};
        if (this.options.ranges) this.yylloc.range = [0,0];
        this.offset = 0;
        return this;
    },
input:function () {
        var ch = this._input[0];
        this.yytext += ch;
        this.yyleng++;
        this.offset++;
        this.match += ch;
        this.matched += ch;
        var lines = ch.match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno++;
            this.yylloc.last_line++;
        } else {
            this.yylloc.last_column++;
        }
        if (this.options.ranges) this.yylloc.range[1]++;

        this._input = this._input.slice(1);
        return ch;
    },
unput:function (ch) {
        var len = ch.length;
        var lines = ch.split(/(?:\r\n?|\n)/g);

        this._input = ch + this._input;
        this.yytext = this.yytext.substr(0, this.yytext.length-len-1);
        //this.yyleng -= len;
        this.offset -= len;
        var oldLines = this.match.split(/(?:\r\n?|\n)/g);
        this.match = this.match.substr(0, this.match.length-1);
        this.matched = this.matched.substr(0, this.matched.length-1);

        if (lines.length-1) this.yylineno -= lines.length-1;
        var r = this.yylloc.range;

        this.yylloc = {first_line: this.yylloc.first_line,
          last_line: this.yylineno+1,
          first_column: this.yylloc.first_column,
          last_column: lines ?
              (lines.length === oldLines.length ? this.yylloc.first_column : 0) + oldLines[oldLines.length - lines.length].length - lines[0].length:
              this.yylloc.first_column - len
          };

        if (this.options.ranges) {
            this.yylloc.range = [r[0], r[0] + this.yyleng - len];
        }
        return this;
    },
more:function () {
        this._more = true;
        return this;
    },
less:function (n) {
        this.unput(this.match.slice(n));
    },
pastInput:function () {
        var past = this.matched.substr(0, this.matched.length - this.match.length);
        return (past.length > 20 ? '...':'') + past.substr(-20).replace(/\n/g, "");
    },
upcomingInput:function () {
        var next = this.match;
        if (next.length < 20) {
            next += this._input.substr(0, 20-next.length);
        }
        return (next.substr(0,20)+(next.length > 20 ? '...':'')).replace(/\n/g, "");
    },
showPosition:function () {
        var pre = this.pastInput();
        var c = new Array(pre.length + 1).join("-");
        return pre + this.upcomingInput() + "\n" + c+"^";
    },
next:function () {
        if (this.done) {
            return this.EOF;
        }
        if (!this._input) this.done = true;

        var token,
            match,
            tempMatch,
            index,
            col,
            lines;
        if (!this._more) {
            this.yytext = '';
            this.match = '';
        }
        var rules = this._currentRules();
        for (var i=0;i < rules.length; i++) {
            tempMatch = this._input.match(this.rules[rules[i]]);
            if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                match = tempMatch;
                index = i;
                if (!this.options.flex) break;
            }
        }
        if (match) {
            lines = match[0].match(/(?:\r\n?|\n).*/g);
            if (lines) this.yylineno += lines.length;
            this.yylloc = {first_line: this.yylloc.last_line,
                           last_line: this.yylineno+1,
                           first_column: this.yylloc.last_column,
                           last_column: lines ? lines[lines.length-1].length-lines[lines.length-1].match(/\r?\n?/)[0].length : this.yylloc.last_column + match[0].length};
            this.yytext += match[0];
            this.match += match[0];
            this.matches = match;
            this.yyleng = this.yytext.length;
            if (this.options.ranges) {
                this.yylloc.range = [this.offset, this.offset += this.yyleng];
            }
            this._more = false;
            this._input = this._input.slice(match[0].length);
            this.matched += match[0];
            token = this.performAction.call(this, this.yy, this, rules[index],this.conditionStack[this.conditionStack.length-1]);
            if (this.done && this._input) this.done = false;
            if (token) return token;
            else return;
        }
        if (this._input === "") {
            return this.EOF;
        } else {
            return this.parseError('Lexical error on line '+(this.yylineno+1)+'. Unrecognized text.\n'+this.showPosition(),
                    {text: "", token: null, line: this.yylineno});
        }
    },
lex:function lex() {
        var r = this.next();
        if (typeof r !== 'undefined') {
            return r;
        } else {
            return this.lex();
        }
    },
begin:function begin(condition) {
        this.conditionStack.push(condition);
    },
popState:function popState() {
        return this.conditionStack.pop();
    },
_currentRules:function _currentRules() {
        return this.conditions[this.conditionStack[this.conditionStack.length-1]].rules;
    },
topState:function () {
        return this.conditionStack[this.conditionStack.length-2];
    },
pushState:function begin(condition) {
        this.begin(condition);
    }});
lexer.options = {};
lexer.performAction = function anonymous(yy,yy_,$avoiding_name_collisions,YY_START) {


function strip(start, end) {
  return yy_.yytext = yy_.yytext.substr(start, yy_.yyleng-end);
}


var YYSTATE=YY_START
switch($avoiding_name_collisions) {
case 0:
                                   if(yy_.yytext.slice(-2) === "\\\\") {
                                     strip(0,1);
                                     this.begin("mu");
                                   } else if(yy_.yytext.slice(-1) === "\\") {
                                     strip(0,1);
                                     this.begin("emu");
                                   } else {
                                     this.begin("mu");
                                   }
                                   if(yy_.yytext) return 12;
                                 
break;
case 1:return 12;
break;
case 2:
                                   this.popState();
                                   return 12;
                                 
break;
case 3:
                                  yy_.yytext = yy_.yytext.substr(5, yy_.yyleng-9);
                                  this.popState();
                                  return 15;
                                 
break;
case 4: return 12; 
break;
case 5:strip(0,4); this.popState(); return 13;
break;
case 6:return 45;
break;
case 7:return 46;
break;
case 8: return 16; 
break;
case 9:
                                  this.popState();
                                  this.begin('raw');
                                  return 18;
                                 
break;
case 10:return 34;
break;
case 11:return 24;
break;
case 12:return 29;
break;
case 13:this.popState(); return 28;
break;
case 14:this.popState(); return 28;
break;
case 15:return 26;
break;
case 16:return 26;
break;
case 17:return 32;
break;
case 18:return 31;
break;
case 19:this.popState(); this.begin('com');
break;
case 20:strip(3,5); this.popState(); return 13;
break;
case 21:return 31;
break;
case 22:return 51;
break;
case 23:return 50;
break;
case 24:return 50;
break;
case 25:return 54;
break;
case 26:// ignore whitespace
break;
case 27:this.popState(); return 33;
break;
case 28:this.popState(); return 25;
break;
case 29:yy_.yytext = strip(1,2).replace(/\\"/g,'"'); return 42;
break;
case 30:yy_.yytext = strip(1,2).replace(/\\'/g,"'"); return 42;
break;
case 31:return 52;
break;
case 32:return 44;
break;
case 33:return 44;
break;
case 34:return 43;
break;
case 35:return 50;
break;
case 36:yy_.yytext = strip(1,2); return 50;
break;
case 37:return 'INVALID';
break;
case 38:return 5;
break;
}
};
lexer.rules = [/^(?:[^\x00]*?(?=(\{\{)))/,/^(?:[^\x00]+)/,/^(?:[^\x00]{2,}?(?=(\{\{|\\\{\{|\\\\\{\{|$)))/,/^(?:\{\{\{\{\/[^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=[=}\s\/.])\}\}\}\})/,/^(?:[^\x00]*?(?=(\{\{\{\{\/)))/,/^(?:[\s\S]*?--\}\})/,/^(?:\()/,/^(?:\))/,/^(?:\{\{\{\{)/,/^(?:\}\}\}\})/,/^(?:\{\{(~)?>)/,/^(?:\{\{(~)?#)/,/^(?:\{\{(~)?\/)/,/^(?:\{\{(~)?\^\s*(~)?\}\})/,/^(?:\{\{(~)?\s*else\s*(~)?\}\})/,/^(?:\{\{(~)?\^)/,/^(?:\{\{(~)?\s*else\b)/,/^(?:\{\{(~)?\{)/,/^(?:\{\{(~)?&)/,/^(?:\{\{!--)/,/^(?:\{\{![\s\S]*?\}\})/,/^(?:\{\{(~)?)/,/^(?:=)/,/^(?:\.\.)/,/^(?:\.(?=([=~}\s\/.)])))/,/^(?:[\/.])/,/^(?:\s+)/,/^(?:\}(~)?\}\})/,/^(?:(~)?\}\})/,/^(?:"(\\["]|[^"])*")/,/^(?:'(\\[']|[^'])*')/,/^(?:@)/,/^(?:true(?=([~}\s)])))/,/^(?:false(?=([~}\s)])))/,/^(?:-?[0-9]+(?:\.[0-9]+)?(?=([~}\s)])))/,/^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.)]))))/,/^(?:\[[^\]]*\])/,/^(?:.)/,/^(?:$)/];
lexer.conditions = {"mu":{"rules":[6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38],"inclusive":false},"emu":{"rules":[2],"inclusive":false},"com":{"rules":[5],"inclusive":false},"raw":{"rules":[3,4],"inclusive":false},"INITIAL":{"rules":[0,1,38],"inclusive":true}};
return lexer;})()
parser.lexer = lexer;
function Parser () { this.yy = {}; }Parser.prototype = parser;parser.Parser = Parser;
return new Parser;
})();exports["default"] = handlebars;
/* jshint ignore:end */
});
},{"async-define":1}],12:[function(require,module,exports){
require('async-define')(["jquery-1.11"],function (__jquery){
"use strict";
var Visitor = require("./visitor")["default"];

function print(ast) {
  return new PrintVisitor().accept(ast);
}

exports.print = print;function PrintVisitor() {
  this.padding = 0;
}

exports.PrintVisitor = PrintVisitor;PrintVisitor.prototype = new Visitor();

PrintVisitor.prototype.pad = function(string) {
  var out = "";

  for(var i=0,l=this.padding; i<l; i++) {
    out = out + "  ";
  }

  out = out + string + "\n";
  return out;
};

PrintVisitor.prototype.program = function(program) {
  var out = "",
      statements = program.statements,
      i, l;

  for(i=0, l=statements.length; i<l; i++) {
    out = out + this.accept(statements[i]);
  }

  this.padding--;

  return out;
};

PrintVisitor.prototype.block = function(block) {
  var out = "";

  out = out + this.pad("BLOCK:");
  this.padding++;
  out = out + this.accept(block.mustache);
  if (block.program) {
    out = out + this.pad("PROGRAM:");
    this.padding++;
    out = out + this.accept(block.program);
    this.padding--;
  }
  if (block.inverse) {
    if (block.program) { this.padding++; }
    out = out + this.pad("{{^}}");
    this.padding++;
    out = out + this.accept(block.inverse);
    this.padding--;
    if (block.program) { this.padding--; }
  }
  this.padding--;

  return out;
};

PrintVisitor.prototype.sexpr = function(sexpr) {
  var params = sexpr.params, paramStrings = [], hash;

  for(var i=0, l=params.length; i<l; i++) {
    paramStrings.push(this.accept(params[i]));
  }

  params = "[" + paramStrings.join(", ") + "]";

  hash = sexpr.hash ? " " + this.accept(sexpr.hash) : "";

  return this.accept(sexpr.id) + " " + params + hash;
};

PrintVisitor.prototype.mustache = function(mustache) {
  return this.pad("{{ " + this.accept(mustache.sexpr) + " }}");
};

PrintVisitor.prototype.partial = function(partial) {
  var content = this.accept(partial.partialName);
  if(partial.context) {
    content += " " + this.accept(partial.context);
  }
  if (partial.hash) {
    content += " " + this.accept(partial.hash);
  }
  return this.pad("{{> " + content + " }}");
};

PrintVisitor.prototype.hash = function(hash) {
  var pairs = hash.pairs;
  var joinedPairs = [], left, right;

  for(var i=0, l=pairs.length; i<l; i++) {
    left = pairs[i][0];
    right = this.accept(pairs[i][1]);
    joinedPairs.push( left + "=" + right );
  }

  return "HASH{" + joinedPairs.join(", ") + "}";
};

PrintVisitor.prototype.STRING = function(string) {
  return '"' + string.string + '"';
};

PrintVisitor.prototype.NUMBER = function(number) {
  return "NUMBER{" + number.number + "}";
};

PrintVisitor.prototype.BOOLEAN = function(bool) {
  return "BOOLEAN{" + bool.bool + "}";
};

PrintVisitor.prototype.ID = function(id) {
  var path = id.parts.join("/");
  if(id.parts.length > 1) {
    return "PATH:" + path;
  } else {
    return "ID:" + path;
  }
};

PrintVisitor.prototype.PARTIAL_NAME = function(partialName) {
    return "PARTIAL:" + partialName.name;
};

PrintVisitor.prototype.DATA = function(data) {
  return "@" + this.accept(data.id);
};

PrintVisitor.prototype.content = function(content) {
  return this.pad("CONTENT[ '" + content.string + "' ]");
};

PrintVisitor.prototype.comment = function(comment) {
  return this.pad("{{! '" + comment.comment + "' }}");
};
});
},{"./visitor":13,"async-define":1}],13:[function(require,module,exports){
require('async-define')(["jquery-1.11"],function (__jquery){
"use strict";
function Visitor() {}

Visitor.prototype = {
  constructor: Visitor,

  accept: function(object) {
    return this[object.type](object);
  }
};

exports["default"] = Visitor;
});
},{"async-define":1}],14:[function(require,module,exports){
require('async-define')(["jquery-1.11"],function (__jquery){
"use strict";

var errorProps = ['description', 'fileName', 'lineNumber', 'message', 'name', 'number', 'stack'];

function Exception(message, node) {
  var line;
  if (node && node.firstLine) {
    line = node.firstLine;

    message += ' - ' + line + ':' + node.firstColumn;
  }

  var tmp = Error.prototype.constructor.call(this, message);

  // Unfortunately errors are not enumerable in Chrome (at least), so `for prop in tmp` doesn't work.
  for (var idx = 0; idx < errorProps.length; idx++) {
    this[errorProps[idx]] = tmp[errorProps[idx]];
  }

  if (line) {
    this.lineNumber = line;
    this.column = node.firstColumn;
  }
}

Exception.prototype = new Error();

exports["default"] = Exception;
});
},{"async-define":1}],15:[function(require,module,exports){
require('async-define')(["jquery-1.11"],function (__jquery){
"use strict";
var Utils = require("./utils");
var Exception = require("./exception")["default"];
var COMPILER_REVISION = require("./base").COMPILER_REVISION;
var REVISION_CHANGES = require("./base").REVISION_CHANGES;
var createFrame = require("./base").createFrame;

function checkRevision(compilerInfo) {
  var compilerRevision = compilerInfo && compilerInfo[0] || 1,
      currentRevision = COMPILER_REVISION;

  if (compilerRevision !== currentRevision) {
    if (compilerRevision < currentRevision) {
      var runtimeVersions = REVISION_CHANGES[currentRevision],
          compilerVersions = REVISION_CHANGES[compilerRevision];
      throw new Exception("Template was precompiled with an older version of Handlebars than the current runtime. "+
            "Please update your precompiler to a newer version ("+runtimeVersions+") or downgrade your runtime to an older version ("+compilerVersions+").");
    } else {
      // Use the embedded version info since the runtime doesn't know about this revision yet
      throw new Exception("Template was precompiled with a newer version of Handlebars than the current runtime. "+
            "Please update your runtime to a newer version ("+compilerInfo[1]+").");
    }
  }
}

exports.checkRevision = checkRevision;// TODO: Remove this line and break up compilePartial

function template(templateSpec, env) {
  /* istanbul ignore next */
  if (!env) {
    throw new Exception("No environment passed to template");
  }
  if (!templateSpec || !templateSpec.main) {
    throw new Exception('Unknown template object: ' + typeof templateSpec);
  }

  // Note: Using env.VM references rather than local var references throughout this section to allow
  // for external users to override these as psuedo-supported APIs.
  env.VM.checkRevision(templateSpec.compiler);

  var invokePartialWrapper = function(partial, indent, name, context, hash, helpers, partials, data, depths) {
    if (hash) {
      context = Utils.extend({}, context, hash);
    }

    var result = env.VM.invokePartial.call(this, partial, name, context, helpers, partials, data, depths);

    if (result == null && env.compile) {
      var options = { helpers: helpers, partials: partials, data: data, depths: depths };
      partials[name] = env.compile(partial, { data: data !== undefined, compat: templateSpec.compat }, env);
      result = partials[name](context, options);
    }
    if (result != null) {
      if (indent) {
        var lines = result.split('\n');
        for (var i = 0, l = lines.length; i < l; i++) {
          if (!lines[i] && i + 1 === l) {
            break;
          }

          lines[i] = indent + lines[i];
        }
        result = lines.join('\n');
      }
      return result;
    } else {
      throw new Exception("The partial " + name + " could not be compiled when running in runtime-only mode");
    }
  };

  // Just add water
  var container = {
    lookup: function(depths, name) {
      var len = depths.length;
      for (var i = 0; i < len; i++) {
        if (depths[i] && depths[i][name] != null) {
          return depths[i][name];
        }
      }
    },
    lambda: function(current, context) {
      return typeof current === 'function' ? current.call(context) : current;
    },

    escapeExpression: Utils.escapeExpression,
    invokePartial: invokePartialWrapper,

    fn: function(i) {
      return templateSpec[i];
    },

    programs: [],
    program: function(i, data, depths) {
      var programWrapper = this.programs[i],
          fn = this.fn(i);
      if (data || depths) {
        programWrapper = program(this, i, fn, data, depths);
      } else if (!programWrapper) {
        programWrapper = this.programs[i] = program(this, i, fn);
      }
      return programWrapper;
    },

    data: function(data, depth) {
      while (data && depth--) {
        data = data._parent;
      }
      return data;
    },
    merge: function(param, common) {
      var ret = param || common;

      if (param && common && (param !== common)) {
        ret = Utils.extend({}, common, param);
      }

      return ret;
    },

    noop: env.VM.noop,
    compilerInfo: templateSpec.compiler
  };

  var ret = function(context, options) {
    options = options || {};
    var data = options.data;

    ret._setup(options);
    if (!options.partial && templateSpec.useData) {
      data = initData(context, data);
    }
    var depths;
    if (templateSpec.useDepths) {
      depths = options.depths ? [context].concat(options.depths) : [context];
    }

    return templateSpec.main.call(container, context, container.helpers, container.partials, data, depths);
  };
  ret.isTop = true;

  ret._setup = function(options) {
    if (!options.partial) {
      container.helpers = container.merge(options.helpers, env.helpers);

      if (templateSpec.usePartial) {
        container.partials = container.merge(options.partials, env.partials);
      }
    } else {
      container.helpers = options.helpers;
      container.partials = options.partials;
    }
  };

  ret._child = function(i, data, depths) {
    if (templateSpec.useDepths && !depths) {
      throw new Exception('must pass parent depths');
    }

    return program(container, i, templateSpec[i], data, depths);
  };
  return ret;
}

exports.template = template;function program(container, i, fn, data, depths) {
  var prog = function(context, options) {
    options = options || {};

    return fn.call(container, context, container.helpers, container.partials, options.data || data, depths && [context].concat(depths));
  };
  prog.program = i;
  prog.depth = depths ? depths.length : 0;
  return prog;
}

exports.program = program;function invokePartial(partial, name, context, helpers, partials, data, depths) {
  var options = { partial: true, helpers: helpers, partials: partials, data: data, depths: depths };

  if(partial === undefined) {
    throw new Exception("The partial " + name + " could not be found");
  } else if(partial instanceof Function) {
    return partial(context, options);
  }
}

exports.invokePartial = invokePartial;function noop() { return ""; }

exports.noop = noop;function initData(context, data) {
  if (!data || !('root' in data)) {
    data = data ? createFrame(data) : {};
    data.root = context;
  }
  return data;
}
});
},{"./base":5,"./exception":14,"./utils":17,"async-define":1}],16:[function(require,module,exports){
require('async-define')(["jquery-1.11"],function (__jquery){
"use strict";
// Build out our basic SafeString type
function SafeString(string) {
  this.string = string;
}

SafeString.prototype.toString = function() {
  return "" + this.string;
};

exports["default"] = SafeString;
});
},{"async-define":1}],17:[function(require,module,exports){
require('async-define')(["jquery-1.11"],function (__jquery){
"use strict";
/*jshint -W004 */
var SafeString = require("./safe-string")["default"];

var escape = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#x27;",
  "`": "&#x60;"
};

var badChars = /[&<>"'`]/g;
var possible = /[&<>"'`]/;

function escapeChar(chr) {
  return escape[chr];
}

function extend(obj /* , ...source */) {
  for (var i = 1; i < arguments.length; i++) {
    for (var key in arguments[i]) {
      if (Object.prototype.hasOwnProperty.call(arguments[i], key)) {
        obj[key] = arguments[i][key];
      }
    }
  }

  return obj;
}

exports.extend = extend;var toString = Object.prototype.toString;
exports.toString = toString;
// Sourced from lodash
// https://github.com/bestiejs/lodash/blob/master/LICENSE.txt
var isFunction = function(value) {
  return typeof value === 'function';
};
// fallback for older versions of Chrome and Safari
/* istanbul ignore next */
if (isFunction(/x/)) {
  isFunction = function(value) {
    return typeof value === 'function' && toString.call(value) === '[object Function]';
  };
}
var isFunction;
exports.isFunction = isFunction;
/* istanbul ignore next */
var isArray = Array.isArray || function(value) {
  return (value && typeof value === 'object') ? toString.call(value) === '[object Array]' : false;
};
exports.isArray = isArray;

function escapeExpression(string) {
  // don't escape SafeStrings, since they're already safe
  if (string instanceof SafeString) {
    return string.toString();
  } else if (string == null) {
    return "";
  } else if (!string) {
    return string + '';
  }

  // Force a string conversion as this will be done by the append regardless and
  // the regex test will do this transparently behind the scenes, causing issues if
  // an object's to string has escaped characters in it.
  string = "" + string;

  if(!possible.test(string)) { return string; }
  return string.replace(badChars, escapeChar);
}

exports.escapeExpression = escapeExpression;function isEmpty(value) {
  if (!value && value !== 0) {
    return true;
  } else if (isArray(value) && value.length === 0) {
    return true;
  } else {
    return false;
  }
}

exports.isEmpty = isEmpty;function appendContextPath(contextPath, id) {
  return (contextPath ? contextPath + '.' : '') + id;
}

exports.appendContextPath = appendContextPath;
});
},{"./safe-string":16,"async-define":1}],18:[function(require,module,exports){
require('async-define')(["jquery-1.11"],function (__jquery){
// USAGE:
// var handlebars = require('handlebars');

// var local = handlebars.create();

var handlebars = require('../dist/cjs/handlebars')["default"];

handlebars.Visitor = require('../dist/cjs/handlebars/compiler/visitor')["default"];

var printer = require('../dist/cjs/handlebars/compiler/printer');
handlebars.PrintVisitor = printer.PrintVisitor;
handlebars.print = printer.print;

module.exports = handlebars;

// Publish a Node.js require() handler for .handlebars and .hbs files
/* istanbul ignore else */
if (typeof require !== 'undefined' && require.extensions) {
  var extension = function(module, filename) {
    var fs = require("fs");
    var templateString = fs.readFileSync(filename, "utf8");
    module.exports = handlebars.compile(templateString);
  };
  require.extensions[".handlebars"] = extension;
  require.extensions[".hbs"] = extension;
}

});
},{"../dist/cjs/handlebars":3,"../dist/cjs/handlebars/compiler/printer":12,"../dist/cjs/handlebars/compiler/visitor":13,"async-define":1,"fs":2}],19:[function(require,module,exports){
require('async-define')(["jquery-1.11"],function (__jquery){
var jQuery = __jquery;

var panelToggle = require('./masthead/panel-toggle');
var menuToggle = require('./masthead/menu-toggle');
var requestProfile = require('./masthead/request-profile');
var siteCountry = require('./masthead/siteCountry');
var activityAlert = require('./masthead/activity-alert');
var viewportWidth = require('./masthead/tes-media-queries');

var events = window.TES.events;

// fire on document ready as this script might be called from <head>
jQuery(document).ready(function() {
  var avatarImage = function (element, imageUrl) {
    element.onerror = function() {
      element.src = window.TES.siteAssetsCDN + 'img/avatar_small.jpg';
    };
    element.src = imageUrl;
  };

  var $container = jQuery('.new-header-wrapper .nav');

  if (!window || !window.location || !window.location.host) {
    return;
  }

  panelToggle($container, viewportWidth);
  menuToggle($container);
  requestProfile($container);
  siteCountry();
  activityAlert($container);
});

events.one('logged-in', function() {
  requestProfile($container);
});

});
},{"./masthead/activity-alert":20,"./masthead/menu-toggle":21,"./masthead/panel-toggle":23,"./masthead/request-profile":24,"./masthead/siteCountry":25,"./masthead/tes-media-queries":26,"async-define":1}],20:[function(require,module,exports){
require('async-define')(["jquery-1.11"],function (__jquery){
var jQuery = __jquery;
var Cookies = window.Cookies;

module.exports = function activityAlert($container) {
  var navHome = $container.find('.js-nav-home');
  var toggleIcon = $container.find('.js-toggle-icon');

  if ((typeof Cookies !== 'undefined') && !Cookies.get('TESCookieUser') || !navHome) {
    return;
  }

  var notificationUrl = '/api/v1/notifications';
  var refreshTimer = 1000 * 30;
  var activityAlertBubble = document.createElement('span');
  activityAlertBubble.className = 'alert-bubble';

  function updateNotificationCount(notificationCount) {
    if (!document.body.contains(activityAlertBubble)) {
      navHome.append(activityAlertBubble);
      toggleIcon.addClass('icon-bars--notify-circle');
    }
    activityAlertBubble.textContent = notificationCount;
  }

  function checkForActivity() {
    jQuery.get(notificationUrl)
      .done(function (data) {
        if(typeof data.notifications === "number" && data.notifications > 0 ){
          var alertBubbleText = data.notifications > 9 ? '9+' : data.notifications;
          updateNotificationCount(alertBubbleText);
        }
      })
  }

  if (Boolean(window.location.pathname.match(/^\/uk\/$|^\/uk$|^\/([?]{1}.*)?$/))){
    setInterval(checkForActivity, refreshTimer);
  } else {
    checkForActivity();
  }
};

});
},{"async-define":1}],21:[function(require,module,exports){
require('async-define')(["jquery-1.11"],function (__jquery){
var jQuery = __jquery;
var viewportWidth = require('./tes-media-queries');

module.exports = function($container) {

// change menu items (only on mobile, otherwise allow link to reload page)
  $container.on('click', '.js-nav-menu-item', function (e) {

    if (viewportWidth.small.down()) {
      var $container_,
        $trigger = jQuery(this),
        offsetTop = $trigger.offset().top;

      $container_ = $trigger.closest('.js-nav-menu-items');

      // activate button & associated submenus
      $trigger
        .add($container_.find($trigger.attr('data-target')))
        .toggleClass('active');

      // deactivate other buttons & associated submenus
      $container_
        .find('.js-nav-menu-item')
        .not($trigger)
        .each(function () {
          var $that = jQuery(this);
          $that.removeClass('active');
          $container_.find($that.attr('data-target')).removeClass('active');
        });

      /* if submenus above the clicked item are now closed, it may have scrolled off screen.
      So scroll the document to bring it back into view.
       */
      if ($trigger.offset().top !== offsetTop) {
        jQuery(document).scrollTop($trigger.offset().top - offsetTop);
      }

      /* this event could be picked up by other components, eg. to crop document height to the new
      popup height */
      $container_.trigger('heightChange');

      e.preventDefault();
    }

  });
};

});
},{"./tes-media-queries":26,"async-define":1}],22:[function(require,module,exports){
require('async-define')(["jquery-1.11"],function (__jquery){
var jQuery = __jquery;
var Cookies = window.Cookies;

module.exports = function notifications() {
  jQuery('.js-toggle-notification').each(function(){

    var $this = jQuery(this);
    var toggleStateCookieName = $this.attr('data-toggle-state-cookie-name');
    //if no cookie attribute, means just show it
    if(!toggleStateCookieName) {
      $this.click();
      window._mz.emit(window._mze.DISPLAY, {
        source: {
          type: $this.attr('data-mzType') || 'panel',
          name: $this.attr('data-mzName') || 'panel-showed'
        }
      });
    }
    else {
      //toggle based on cookie
      if(Cookies) {
        if(!Cookies.get(toggleStateCookieName)) {
          window._mz.emit(window._mze.DISPLAY, {
            source: {
              type: $this.attr('data-mzType') || 'panel',
              name: $this.attr('data-mzName') || 'panel-showed'
            }
          });
          $this.click();
          $this.click(function(e){
            window._mz.emit(window._mze.CLOSE, {
              source: {
                type: $this.attr('data-mzType') || 'panel',
                name: $this.attr('data-mzName') || 'panel-closed'
              }
            });
            //cookie needs to be set on domain, not just sub domain
            var topLevelDomain = window.location.hostname.split('.');
            topLevelDomain.shift();
            topLevelDomain = topLevelDomain.join('.');
            Cookies.set(toggleStateCookieName, 'true', {
              domain: topLevelDomain,
              expires: '01/01/2030'
            });
          });
        }
      }
      else {
        if(window.console) console.error('No cookie plugin found. It should be included globally.')
      }
    }

  });
};

});
},{"async-define":1}],23:[function(require,module,exports){
require('async-define')(["jquery-1.11"],function (__jquery){
var jQuery = __jquery;
var Cookies = window.Cookies;

function panelToggle($container, viewportWidth) {

  function toggle ($trigger, forceAction) {

    var $target = $container.find($trigger.attr('data-target')),
      $targetHide = $container.find($trigger.attr('data-target-hide')),
      $targetFocus = $container.find($trigger.attr('data-target-focus')),
      $pairedTriggers = $container.find($trigger.attr('data-paired-with')),
      fn;

    fn = forceAction ? forceAction + 'Class' : 'toggleClass';
    $trigger[fn]('active');
    fn = ($trigger.hasClass('active')) ? 'addClass' : 'removeClass';
    $target[fn]('active');
    $pairedTriggers[fn]('active');
    $targetHide[fn]('hidden');

    if ($target.hasClass('active')) {
      if ($targetFocus.length) {
        $targetFocus.focus();
      }
    }
  }

  function stretchPanel($panel) {
    var heightDiff,
      viewportHeight,
      documentHeight,
      popupHeight,
      $bodyContent;

    if (viewportWidth.medium.up()) {
      return;
    }

    if (!jQuery('.new-header-wrapper, .js-masthead').length) {
      return;
    }
    $bodyContent = jQuery('body > *').filter(function (){
      return !jQuery.contains(this, $panel.get(0)) && !$panel.is(this);
    });
    if ($panel.hasClass('active')) {
      $panel.css('min-height', 0);
      // stretch popup to height of document (style will take effect on mobile only)
      viewportHeight = jQuery(window).height();
      heightDiff = viewportHeight - $panel.outerHeight();
      // set new document height to match whichever is taller - the popup or the viewport
      documentHeight = (heightDiff < 0) ? $panel.outerHeight() : viewportHeight;
      // account for menu bar above popup
      popupHeight = documentHeight - $panel.offset().top;
      $panel.css('min-height', popupHeight + 'px');
      // Hide contents of body
      $bodyContent.addClass('hidden');
    } else {
      $bodyContent.removeClass('hidden');
    }
  }

  // toggle panels
  $container.on('click', '.js-toggle', function (e) {
    var $trigger,
      targetPanel,
      $otherPanels;

    /* execute the toggle only if:
     - the button hasn't been tagged as 'trigger JS function in small media query only'
     or
     - if it has been tagged as above, then if the viewport is sized small
     */
    $trigger = jQuery(this);
    if (!$trigger.attr('data-js-mq-small-only') || (viewportWidth.small.down())) {
      targetPanel = $trigger.attr('data-target');
      toggle($trigger);
      stretchPanel($container.find(targetPanel));
      $container.find(targetPanel).on('heightChange', function() {
        stretchPanel(jQuery(this));
      });

      $otherPanels = $container.find('.js-toggle').not('[data-target="' + targetPanel + '"]');
      $otherPanels.each(function () {
        toggle(jQuery(this), 'remove');
      });

      // TODO - fix MZ bug around link clicks / firing double events
      if (!$trigger.is('a') && (typeof window._mz !== 'undefined')) {
        window._mz.emit(window._mze.CLICK, {
          eventTitle: $trigger.attr('data-mz-event-title')
        });
      }
      e.preventDefault();
    }
  });

  //close the panel if clicked outside
  jQuery(document).mouseup(function (e) {
    if(!$container.find('.js-toggle').length) return;
    var $openedPanelsToggles = $container.find('.js-toggle.active[data-close-click-outside]');
    if(!$openedPanelsToggles.length) return;
    $openedPanelsToggles.each(function(){
      var $this = jQuery(this);
      var $panel = jQuery($this.attr('data-target'));
      if($panel.find(e.target).length === 0 && $(e.target).closest('.js-toggle')[0] !== $(this)[0]) {
        $this.click();
      }
    });
  });

  //load panel if previous state is found cookie
  $container.find('.js-toggle').each(function () {
    var $this = jQuery(this);
    var previousStateCookieName = $this.attr('data-previous-state-cookie-name');
    if (previousStateCookieName) {
      if (Cookies) {
        if (Cookies.get(previousStateCookieName)) {
          $this.click(); //show it
        }
        $this.click(function () {
          setTimeout(function () { //make sure menu opening and closing is finished
            //cookie needs to be set on domain, not just sub domain
            var topLevelDomain = window.location.hostname.split('.');
            topLevelDomain.shift();
            topLevelDomain = topLevelDomain.join('.');
            if ($this.hasClass('active')) {
              Cookies.set(previousStateCookieName, 'true', {
                domain: topLevelDomain,
                expires: '01/01/2030'
              });
            }
            else {
              Cookies.set(previousStateCookieName, undefined, {
                domain: topLevelDomain,
                expires: '01/01/1970'
              });
            }
          }, 0);//setTimeout
        }); // $this.click
      } //if(Cookie)
    }// if(previousStateCookieName)
  });
}

module.exports = panelToggle;

});
},{"async-define":1}],24:[function(require,module,exports){
require('async-define')(["jquery-1.11"],function (__jquery){
var jQuery = __jquery;
var notifications = require('./notifications');
var templates = require('../../templates/compiled/frontend/templates');

var urlData = {
  "myResources": "/my-resources/downloads",
  "balance": "/my-resources/buyer-dashboard",
  "sellerTier": "/my-resources/seller-tier",
  "myUploads": "/my-resources/uploads",
  "authorDashboard": "/teaching-resources/dashboard?dashType=new",
  "myDownloads": "/my-resources/downloads",
  "myShop": "/teaching-resources/shop/myshop",
  "addResource": "/teaching-resource/upload",
  "createBundle": "/teaching-resources/bundler",
  "manageSales": "/teaching-resources/sales-tool",
  "talentBank": "/jobs/talentbank.aspx",
  "myJobs": "/jobs/myjobs/savedjobs",
  "myCareerProfile": "/member/[[username]]/career-profile",
  "myJobSearches": "/jobs/myjobs/savedsearches",
  "myCourses": "/mycourses/",
  "myForums": "/watched/forums",
  "myFollowers": "/member/[[username]]/followers",
  "myFollowing": "/member/[[username]]/following",
  "myThreads": "/watched/threads",
  "myConversations": "/conversations",
  "account": "/authn/account",
  "profile": "/member/[[username]]",
  "products": "/member/[[username]]/subscriptions",
  "preferenceCentre": "/authn/preference-centre",
  "logout": "/api/authn/sign-out-redirect"
};

function extendData(data) {
  urlData.myCommunity = data.communityHost;
  urlData.myForums = data.communityHost + urlData.myForums;
  urlData.myThreads = data.communityHost + urlData.myThreads;
  urlData.myConversations = data.communityHost + urlData.myConversations;
  urlData.myFollowers = urlData.myFollowers.replace('[[username]]', data.username);
  urlData.myFollowing = urlData.myFollowing.replace('[[username]]', data.username);
  urlData.profile = urlData.profile.replace('[[username]]', data.username);
  urlData.products = urlData.products.replace('[[username]]', data.username);
  urlData.myCareerProfile = urlData.myCareerProfile.replace('[[username]]', data.username);
  jQuery.extend(data, urlData);
  return data;
};

module.exports = function requestProfile($container) {
  var Cookies = window.Cookies;
  var siteCountry;
  try {
    siteCountry = Cookies.get('siteCountry').toLowerCase();
  }
  catch (e) {
    siteCountry = 'gb';
  }
  if (!siteCountry) {
    siteCountry = 'gb';
  }

  if ((typeof Cookies !== 'undefined') && !Cookies.get('TESCookieUser')) {
    $container.find('.js-profile').addClass('loaded');
    return;
  }

  // Looks like community.tes.com has it's own profile div thingy.
  if (window.location.hostname.match(/community\.tes\.com/)) {
    return;
  }

  function decodeCookie () {
    var cookie = Cookies.get('TESCookieV2');
    cookie = cookie.split('.')[1];
    return atob(cookie);
  }

  function mySchools () {
    try {
      if(Cookies.get('toggle-agentVis') === '1') return { orgId: 'any', multipleOrgsAdmin: true };
      var orgId = '';
      var orgCount = 0;
      var orgAgentCount = 0;
      var decoded = decodeCookie();
      var orgRoles = JSON.parse(decoded).cache.orgRoles;
      jQuery.each(orgRoles, function(key, val) {
        if ((val.indexOf('orgadmin') > -1) || (val.indexOf('orgrecruiter') > -1)) {
          orgCount = orgCount + 1;
        } else if ((val.indexOf('orgagent') > -1)) {
          orgAgentCount = orgAgentCount + 1;
        }
        return orgId = key;
      });
    } catch(err) {}
    return {
      orgId: orgId,
      multipleOrgsAdmin: orgCount >= 1,      // temporary fix for https://github.com/tes/H2O/issues/820
      multipleOrgsAgent: orgAgentCount >= 1, // don't go right to a single school or give singular text
    };
  }

  //fallback for jobs and other sites where its useless to update footer.xml in .net code for now
  var profileApiUrl = (window.TES && window.TES.apiUrls) ? window.TES.apiUrls.profile : "/api/v1/member";

  function isUserAdmin() {
    try {
      var decoded = decodeCookie();
      var roles = JSON.parse(decoded).cache.roles;
      return !!(~roles.indexOf('resourceadminuser') || ~roles.indexOf('systemadministrator'));
    } catch (e) {
      return false;
    }
  }

  var $profile = $container.find('.js-profile');

  function renderAvatar(data) {
    var profile;
    try {
      if (data == null) return;

      renderBalance(data);

      data = extendData(data);
      // add cache busting to the url as the service isn't doing it anymore.
      if (data.avatarSmall) {
        data.avatarSmall = data.avatarSmall + '?_=' + new Date().getTime();
      }

      /* add My schools link if the user is an org admin for a school */
      var orgData = mySchools(data);
      data.isGB = siteCountry === 'gb';
      data.orgId = orgData.orgId;
      data.multipleOrgsAdmin = orgData.multipleOrgsAdmin;
      data.multipleOrgsAgent = orgData.multipleOrgsAgent;

      profile = templates['header-avatar'](data);
      $profile.html(profile);

      var alreadyLoaded = false;
      $profile.one('click mouseover', function (evt) {
        if (alreadyLoaded) return;
        alreadyLoaded = true;
        jQuery.ajax({url: profileApiUrl, data: { expand: 'subscriptions,balance' }, cache: false, dataType: 'json', xhrFields: { withCredentials: true }})
          .done(function(data) {
            // Display balance in UCP only for certain countries
            if (siteCountry === 'gb' || siteCountry === 'us') {

              // Hack because of conflicting naming between the buyers balance and the balance link url
              data.buyerBalance = data.balance;
            }

            renderBubble(data, siteCountry);
          });
      });

      notifications();
    } catch (e) {
      if(window.console && window.console.log) console.log(e);
    }
  }

  function renderBalance(data) {
    if (data.balance === '£0.00' || data.balance === '$0.00' || data.balance === 'n/a') {
      return;
    }

    var $buyerBalance = jQuery('.js-buyer-balance');
    if ($buyerBalance.length === 0) {
      return;
    }

    var balanceLabel = $buyerBalance.text();
    $buyerBalance.html(balanceLabel.replace('(n/a)', '<b>' + data.balance + '</b>'));
    $buyerBalance.removeClass('hidden');
  }

  function renderBubble(data) {
    var profile;
    try {
      if (data == null) return;

      jQuery.extend(data, urlData, { subscriptions: data.subscriptions });

      // add cache busting to the url as the service isn't doing it anymore.
      if (data.avatarSmall) {
        data.avatarSmall = data.avatarSmall + '?_=' + new Date().getTime();
      }
      if (data.avatarLarge) {
        data.avatarLarge = data.avatarLarge + '?_=' + new Date().getTime();
      }
      data.isAdmin = isUserAdmin();

      /* add My schools link if the user is an org admin for a school */
      var orgData = mySchools(data);
      data.orgId = orgData.orgId;
      data.multipleOrgsAdmin = orgData.multipleOrgsAdmin;
      data.multipleOrgsAgent = orgData.multipleOrgsAgent;

      var templ = templates['header-profile-v3-' + siteCountry] || templates['header-profile-v3-gb'];
      profile = templ(data);
      var $jsProfilePanel = $profile.find('.js-profile-panel');
      $jsProfilePanel.html(profile);
      if (siteCountry === 'us') {
        $jsProfilePanel.addClass('geo-us');
      }
      $profile.addClass('js-panel-loaded');
      // Save it globally and fire event so any app can use this data
      // apparently it is not used anymore, but it doesn't hurt leaving it here
      TES.loggedInData = data;
      jQuery('body').trigger('memberDataLoaded');

    } catch (e) {
      if(window.console && window.console.log) console.log(e);
    }

  }
  // get login status / profile information
  jQuery.ajax({url: profileApiUrl, data: { expand: 'balance' }, cache: false, dataType: 'json', xhrFields: { withCredentials: true }})
    .done(renderAvatar)
    .complete(function () {
      $container.find('.js-profile').addClass('loaded');
    });
};

});
},{"../../templates/compiled/frontend/templates":27,"./notifications":22,"async-define":1}],25:[function(require,module,exports){
require('async-define')(["jquery-1.11"],function (__jquery){
var jQuery = __jquery;
var Cookies = window.Cookies;

function updateCookie(newValue, oldValue) {
  Cookies.set('siteCountry', newValue, {expires: 63072000, domain: window.document.domain.replace('www.','.')});
  if (window.TES.onSiteCountryChanged) {
    window.TES.onSiteCountryChanged(newValue, oldValue);
  } else {
    document.location.reload();
  }
}

module.exports = function siteCountry() {
  var $siteCountrySelect = jQuery('.siteCountry select');
  if (!$siteCountrySelect.length) { return; }
  var siteCountry = Cookies.get('siteCountry');
  $siteCountrySelect.val(siteCountry);
  $siteCountrySelect.on('change', function() {
    var newValue = this.value;
    if (siteCountry === newValue) return;
    var TESCookieV2 = Cookies.get('TESCookieV2');
    if (!Cookies.get('TESCookieUser') || !TESCookieV2) {
      updateCookie(newValue, siteCountry);
      return;
    }

    var url = TES.appAuthnApiUrl + '/change-site-country';

    jQuery.ajax(url, {
        type: 'POST',
        dataType: 'json',
        contentType: 'application/json',
        headers: { 'X-TslAuthJwt': TESCookieV2, 'X-CSRF-Token': Cookies.get('csrf') },
        data: JSON.stringify({ siteCountry: newValue }),
        success: function() {
          updateCookie(newValue, siteCountry);
        },
        error: function() {
          $siteCountrySelect.val(siteCountry);
          window.alert('There was an error. Please log in and try again.');
        }
      }
    );
  });
};

});
},{"async-define":1}],26:[function(require,module,exports){
require('async-define')(["jquery-1.11"],function (__jquery){
var matchMedia = window.matchMedia || window.msMatchMedia;
var mq = matchMedia ? function (m) {
  var mql = matchMedia(m);
  return mql && mql.matches || false;
} : undefined;

// These should match the values in https://github.com/tes/sass/blob/master/variables/_responsive.scss
var breakpoints = {
  XS: 480,
  SM: 768,
  MD: 992,
  LG: 1200
};

var viewportWidth;

if (mq) {
  viewportWidth = {
    small: {
      down: function() {
        return mq('only screen and (max-width: ' + (breakpoints.SM - 1) + 'px)')
      }
    },
    medium: {
      up:  function() {
        return mq('only screen and (min-width: ' + breakpoints.SM + 'px)')
      }
    },
    large: {
      up:  function() {
        return mq('only screen and (min-width: ' + breakpoints.MD + 'px)')
      }
    }
  };
}

module.exports = viewportWidth;

});
},{"async-define":1}],27:[function(require,module,exports){
require('async-define')(["jquery-1.11"],function (__jquery){
var Handlebars = require('handlebars');
module.exports["header-avatar"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.orgId : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"2":function(depth0,helpers,partials,data) {
    var stack1;

  return "  <a class=\"nav__item nav__menu-item nav__menu-item-sm hidden-xs l-vcenter link link--nounderline link--colored-dark border-right t-my-schools padding-right-md\" href=\"\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.multipleOrgsAdmin : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.program(5, data, 0),"data":data})) != null ? stack1 : "")
    + "      \">\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.multipleOrgsAdmin : depth0),{"name":"if","hash":{},"fn":this.program(10, data, 0),"inverse":this.program(12, data, 0),"data":data})) != null ? stack1 : "")
    + "    </a>\n";
},"3":function(depth0,helpers,partials,data) {
    return "      /schools/employers/school-chooser\n";
},"5":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.multipleOrgsAgent : depth0),{"name":"if","hash":{},"fn":this.program(6, data, 0),"inverse":this.program(8, data, 0),"data":data})) != null ? stack1 : "");
},"6":function(depth0,helpers,partials,data) {
    return "        /schools/employers/school-chooser-agent\n";
},"8":function(depth0,helpers,partials,data) {
    var helper;

  return "        /schools/employers/"
    + this.escapeExpression(((helper = (helper = helpers.orgId || (depth0 != null ? depth0.orgId : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"orgId","hash":{},"data":data}) : helper)))
    + "/jobs\n";
},"10":function(depth0,helpers,partials,data) {
    return "      My Schools\n";
},"12":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.multipleOrgsAgent : depth0),{"name":"if","hash":{},"fn":this.program(13, data, 0),"inverse":this.program(15, data, 0),"data":data})) != null ? stack1 : "");
},"13":function(depth0,helpers,partials,data) {
    return "        My Schools\n";
},"15":function(depth0,helpers,partials,data) {
    return "        My School\n";
},"17":function(depth0,helpers,partials,data) {
    return " hidden-xs hidden-sm";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isGB : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "<span class=\"padding-left-sm\">\n  <button\n          class=\"user-avatar avatar--compact tes-btn btn--reset js-toggle t-toggle-profile\"\n          data-target=\".js-profile-panel\"\n          type=\"button\"\n          data-close-click-outside=\"true\"\n          data-mz-event-title=\"profile\">\n    <span class=\"avatar__name js-user-display-name"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.orgId : depth0),{"name":"if","hash":{},"fn":this.program(17, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\">"
    + alias3(((helper = (helper = helpers.displayName || (depth0 != null ? depth0.displayName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"displayName","hash":{},"data":data}) : helper)))
    + "</span>\n      <span class=\"avatar__image\">\n        <span class=\"avatar__image-inner\">\n          <img\n                  class=\"js-avatar\"\n                  src=\""
    + alias3(((helper = (helper = helpers.avatarSmall || (depth0 != null ? depth0.avatarSmall : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"avatarSmall","hash":{},"data":data}) : helper)))
    + "\"\n                  alt=\""
    + alias3(((helper = (helper = helpers.displayName || (depth0 != null ? depth0.displayName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"displayName","hash":{},"data":data}) : helper)))
    + "\"\n                  width=\"40\"\n                  height=\"40\"/>\n        </span>\n      </span>\n  </button>\n</span>\n<div class=\"popup popup--stalk-top-right profile__panel padding-left-md padding-right-md js-profile-panel\">\n</div>\n";
},"useData":true});
module.exports["header-profile-v3-au"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "col-sm-3";
},"3":function(depth0,helpers,partials,data) {
    return "col-sm-4";
},"5":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "    <div class=\"col-xs-12 col-sm-3 profile__subsection\">\n      <h3 class=\"h5 profile__subheading\">\n        <a data-mz class=\"link link--unstyled\" href=\""
    + this.escapeExpression(((helper = (helper = helpers.products || (depth0 != null ? depth0.products : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"products","hash":{},"data":data}) : helper)))
    + "\">\n          My products\n        </a>\n      </h3>\n      <ul class=\"list-unstyled profile__links\">\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.subscriptions : depth0),{"name":"each","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "      </ul>\n    </div>\n";
},"6":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "        <li>\n          <a data-mz class=\"profile__link link link--unstyled\" href=\""
    + alias3(((helper = (helper = helpers.url || (depth0 != null ? depth0.url : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"url","hash":{},"data":data}) : helper)))
    + "\">\n            "
    + alias3(((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"name","hash":{},"data":data}) : helper)))
    + "\n          </a>\n        </li>\n";
},"8":function(depth0,helpers,partials,data) {
    var stack1;

  return "      <li>\n        <a data-mz class=\"t-my-schools profile__link link link--unstyled\" href=\"\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.multipleOrgsAdmin : depth0),{"name":"if","hash":{},"fn":this.program(9, data, 0),"inverse":this.program(11, data, 0),"data":data})) != null ? stack1 : "")
    + "        \">\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.multipleOrgsAdmin : depth0),{"name":"if","hash":{},"fn":this.program(16, data, 0),"inverse":this.program(18, data, 0),"data":data})) != null ? stack1 : "")
    + "        </a>\n      </li>\n";
},"9":function(depth0,helpers,partials,data) {
    return "            /schools/employers/school-chooser\n";
},"11":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.multipleOrgsAgent : depth0),{"name":"if","hash":{},"fn":this.program(12, data, 0),"inverse":this.program(14, data, 0),"data":data})) != null ? stack1 : "");
},"12":function(depth0,helpers,partials,data) {
    return "              /schools/employers/school-chooser-agent\n";
},"14":function(depth0,helpers,partials,data) {
    var helper;

  return "              /schools/employers/"
    + this.escapeExpression(((helper = (helper = helpers.orgId || (depth0 != null ? depth0.orgId : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"orgId","hash":{},"data":data}) : helper)))
    + "/jobs\n";
},"16":function(depth0,helpers,partials,data) {
    return "            My schools\n";
},"18":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.multipleOrgsAgent : depth0),{"name":"if","hash":{},"fn":this.program(19, data, 0),"inverse":this.program(21, data, 0),"data":data})) != null ? stack1 : "");
},"19":function(depth0,helpers,partials,data) {
    return "              My schools\n";
},"21":function(depth0,helpers,partials,data) {
    return "              My school\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "<h2 class=\"sr-only\">Your profile</h2>\n<div class=\"clearfix popup__section row border-bottom\">\n  <div class=\"col-xs-12 col-sm-4 no-margin\">\n    <div class=\"visible-xs pull-right\">\n      <a data-mz data-module=\"logout\" class=\"tes-btn tes-btn--primary t-log-out\" href=\""
    + alias3(((helper = (helper = helpers.logout || (depth0 != null ? depth0.logout : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"logout","hash":{},"data":data}) : helper)))
    + "\">Log out</a>\n    </div>\n    <div class=\"popup__subsection\">\n      <span class=\"user-avatar avatar--img-left\">\n        <span class=\"avatar__image\">\n          <span class=\"avatar__image-inner\">\n            <img\n              class=\"js-avatar\"\n              src=\""
    + alias3(((helper = (helper = helpers.avatarSmall || (depth0 != null ? depth0.avatarSmall : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"avatarSmall","hash":{},"data":data}) : helper)))
    + "\"\n              alt=\""
    + alias3(((helper = (helper = helpers.displayName || (depth0 != null ? depth0.displayName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"displayName","hash":{},"data":data}) : helper)))
    + "\"\n              width=\"40\"\n              height=\"40\"/>\n          </span>\n        </span>\n        <span class=\"avatar__name avatar__name--profile js-user-display-name\">"
    + alias3(((helper = (helper = helpers.displayName || (depth0 != null ? depth0.displayName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"displayName","hash":{},"data":data}) : helper)))
    + "</span>\n      </span>\n    </div>\n  </div>\n  <div data-module=\"popup-links\" class=\"col-xs-12 col-sm-6 margin-top-sm\">\n    <ul class=\"profile__links-list \">\n      <li>\n        <a data-mz class=\"link link--unstyled profile__sublink\" href=\""
    + alias3(((helper = (helper = helpers.profile || (depth0 != null ? depth0.profile : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"profile","hash":{},"data":data}) : helper)))
    + "\">\n          Profile\n        </a>\n      </li>\n      <li>\n        <a data-mz class=\"link link--unstyled profile__sublink\" href=\""
    + alias3(((helper = (helper = helpers.account || (depth0 != null ? depth0.account : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"account","hash":{},"data":data}) : helper)))
    + "\">\n          Account\n        </a>\n      </li>\n      <li>\n        <a data-mz class=\"link link--unstyled profile__sublink\" href=\""
    + alias3(((helper = (helper = helpers.preferenceCentre || (depth0 != null ? depth0.preferenceCentre : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"preferenceCentre","hash":{},"data":data}) : helper)))
    + "\">\n          Email Preferences\n        </a>\n      </li>\n    </ul>\n  </div>\n  <div class=\"col-xs-12 col-sm-2 margin-top-xs hidden-xs\">\n    <div class=\"text-right\">\n      <a data-mz data-module=\"logout\" class=\"tes-btn tes-btn--primary tes-btn--sm t-log-out\" href=\""
    + alias3(((helper = (helper = helpers.logout || (depth0 != null ? depth0.logout : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"logout","hash":{},"data":data}) : helper)))
    + "\">Log out</a>\n    </div>\n  </div>\n</div>\n<div data-module=\"popup-links\" class=\"row popup__section popup__section-border\">\n  <div class=\"col-xs-12 "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.subscriptions : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.subscriptions : depth0),{"name":"unless","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " profile__subsection\">\n    <h3 class=\"h5 profile__subheading\">\n      <a data-mz class=\"link link--unstyled\" href=\""
    + alias3(((helper = (helper = helpers.myResources || (depth0 != null ? depth0.myResources : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"myResources","hash":{},"data":data}) : helper)))
    + "\">\n        My resources\n      </a>\n      <a data-mz class=\"margin-left-xs label label-primary label--primary\" href=\""
    + alias3(((helper = (helper = helpers.balance || (depth0 != null ? depth0.balance : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"balance","hash":{},"data":data}) : helper)))
    + "\">"
    + alias3(((helper = (helper = helpers.buyerBalance || (depth0 != null ? depth0.buyerBalance : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"buyerBalance","hash":{},"data":data}) : helper)))
    + "</a>\n    </h3>\n    <ul class=\"list-unstyled profile__links\">\n      <li>\n        <a data-mz class=\"profile__link link link--unstyled\" href=\""
    + alias3(((helper = (helper = helpers.authorDashboard || (depth0 != null ? depth0.authorDashboard : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"authorDashboard","hash":{},"data":data}) : helper)))
    + "\">\n          Author dashboard\n        </a>\n      </li>\n      <li>\n        <a data-mz class=\"profile__link link link--unstyled js-shop\"\n          href=\""
    + alias3(((helper = (helper = helpers.myShop || (depth0 != null ? depth0.myShop : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"myShop","hash":{},"data":data}) : helper)))
    + "\">\n            My shop\n        </a>\n      </li>\n      <li>\n        <a data-mz class=\"profile__link link link--unstyled\" href=\""
    + alias3(((helper = (helper = helpers.addResource || (depth0 != null ? depth0.addResource : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"addResource","hash":{},"data":data}) : helper)))
    + "\">\n          Add new resource\n        </a>\n      </li>\n      <li>\n        <a data-mz class=\"profile__link link link--unstyled\" href=\""
    + alias3(((helper = (helper = helpers.createBundle || (depth0 != null ? depth0.createBundle : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"createBundle","hash":{},"data":data}) : helper)))
    + "\">\n          Create new bundle\n        </a>\n      </li>\n      <li>\n        <a data-mz class=\"t-manage-sales profile__link link link--unstyled\" href=\""
    + alias3(((helper = (helper = helpers.manageSales || (depth0 != null ? depth0.manageSales : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"manageSales","hash":{},"data":data}) : helper)))
    + "\">\n          My sales\n        </a>\n      </li>\n    </ul>\n  </div>\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.subscriptions : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "  <div class=\"col-xs-12 "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.subscriptions : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.subscriptions : depth0),{"name":"unless","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " profile__subsection\">\n    <h3 class=\"h5 profile__subheading\">\n      <a data-mz class=\"link link--unstyled\" href=\""
    + alias3(((helper = (helper = helpers.myJobs || (depth0 != null ? depth0.myJobs : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"myJobs","hash":{},"data":data}) : helper)))
    + "\">My career</a>\n    </h3>\n    <ul class=\"list-unstyled profile__links\">\n      <li>\n        <a data-mz class=\"profile__link link link--unstyled\" href=\""
    + alias3(((helper = (helper = helpers.myJobs || (depth0 != null ? depth0.myJobs : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"myJobs","hash":{},"data":data}) : helper)))
    + "\">\n          My jobs\n        </a>\n      </li>\n      <li>\n        <a data-mz class=\"profile__link link link--unstyled\" href=\""
    + alias3(((helper = (helper = helpers.myJobSearches || (depth0 != null ? depth0.myJobSearches : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"myJobSearches","hash":{},"data":data}) : helper)))
    + "\">\n          My searches\n        </a>\n      </li>\n      <li>\n        <a data-mz class=\"profile__link link link--unstyled\" href=\""
    + alias3(((helper = (helper = helpers.myCourses || (depth0 != null ? depth0.myCourses : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"myCourses","hash":{},"data":data}) : helper)))
    + "\">\n          My courses\n        </a>\n      </li>\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.orgId : depth0),{"name":"if","hash":{},"fn":this.program(8, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    </ul>\n  </div>\n  <div class=\"col-xs-12 "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.subscriptions : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.subscriptions : depth0),{"name":"unless","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " profile__subsection\">\n    <h3 class=\"h5 profile__subheading\">\n      <a data-mz class=\"link link--unstyled\" href=\""
    + alias3(((helper = (helper = helpers.myCommunity || (depth0 != null ? depth0.myCommunity : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"myCommunity","hash":{},"data":data}) : helper)))
    + "\">\n        My community\n      </a>\n    </h3>\n    <ul class=\"list-unstyled profile__links\">\n      <li>\n        <a data-mz class=\"profile__link link link--unstyled\"\n          href=\""
    + alias3(((helper = (helper = helpers.myForums || (depth0 != null ? depth0.myForums : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"myForums","hash":{},"data":data}) : helper)))
    + "\">\n            My forums\n        </a>\n      </li>\n      <li>\n        <a data-mz class=\"profile__link link link--unstyled\"\n          href=\""
    + alias3(((helper = (helper = helpers.myThreads || (depth0 != null ? depth0.myThreads : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"myThreads","hash":{},"data":data}) : helper)))
    + "\">\n            My threads\n        </a>\n      </li>\n      <li>\n        <a data-mz class=\"profile__link link link--unstyled\"\n          href=\""
    + alias3(((helper = (helper = helpers.myConversations || (depth0 != null ? depth0.myConversations : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"myConversations","hash":{},"data":data}) : helper)))
    + "\">\n            My conversations\n        </a>\n      </li>\n      <li>\n        <a data-mz class=\"profile__link link link--unstyled\"\n          href=\""
    + alias3(((helper = (helper = helpers.myFollowers || (depth0 != null ? depth0.myFollowers : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"myFollowers","hash":{},"data":data}) : helper)))
    + "\">\n            Followers\n        </a>\n      </li>\n      <li>\n        <a data-mz class=\"profile__link link link--unstyled\"\n          href=\""
    + alias3(((helper = (helper = helpers.myFollowing || (depth0 != null ? depth0.myFollowing : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"myFollowing","hash":{},"data":data}) : helper)))
    + "\">\n            Following\n        </a>\n      </li>\n    </ul>\n  </div>\n</div>\n";
},"useData":true});
module.exports["header-profile-v3-gb"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "col-sm-3";
},"3":function(depth0,helpers,partials,data) {
    return "col-sm-4";
},"5":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "      <div class=\"col-xs-12 col-sm-3 profile__subsection\">\n        <h3 class=\"h5 profile__subheading\">\n          <a data-mz class=\"link link--unstyled\" href=\""
    + this.escapeExpression(((helper = (helper = helpers.products || (depth0 != null ? depth0.products : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"products","hash":{},"data":data}) : helper)))
    + "\">\n            My products\n          </a>\n        </h3>\n        <ul class=\"list-unstyled profile__links\">\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.subscriptions : depth0),{"name":"each","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "        </ul>\n      </div>\n";
},"6":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "          <li>\n            <a data-mz class=\"profile__link link link--unstyled\" href=\""
    + alias3(((helper = (helper = helpers.url || (depth0 != null ? depth0.url : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"url","hash":{},"data":data}) : helper)))
    + "\">\n              "
    + alias3(((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"name","hash":{},"data":data}) : helper)))
    + "\n            </a>\n          </li>\n";
},"8":function(depth0,helpers,partials,data) {
    var stack1;

  return "        <li>\n          <a data-mz class=\"t-my-schools profile__link link link--unstyled\" href=\"\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.multipleOrgsAdmin : depth0),{"name":"if","hash":{},"fn":this.program(9, data, 0),"inverse":this.program(11, data, 0),"data":data})) != null ? stack1 : "")
    + "          \">\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.multipleOrgsAdmin : depth0),{"name":"if","hash":{},"fn":this.program(16, data, 0),"inverse":this.program(18, data, 0),"data":data})) != null ? stack1 : "")
    + "          </a>\n        </li>\n";
},"9":function(depth0,helpers,partials,data) {
    return "              /schools/employers/school-chooser\n";
},"11":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.multipleOrgsAgent : depth0),{"name":"if","hash":{},"fn":this.program(12, data, 0),"inverse":this.program(14, data, 0),"data":data})) != null ? stack1 : "");
},"12":function(depth0,helpers,partials,data) {
    return "                /schools/employers/school-chooser-agent\n";
},"14":function(depth0,helpers,partials,data) {
    var helper;

  return "                /schools/employers/"
    + this.escapeExpression(((helper = (helper = helpers.orgId || (depth0 != null ? depth0.orgId : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"orgId","hash":{},"data":data}) : helper)))
    + "/jobs\n";
},"16":function(depth0,helpers,partials,data) {
    return "              My Schools\n";
},"18":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.multipleOrgsAgent : depth0),{"name":"if","hash":{},"fn":this.program(19, data, 0),"inverse":this.program(21, data, 0),"data":data})) != null ? stack1 : "");
},"19":function(depth0,helpers,partials,data) {
    return "                My Schools\n";
},"21":function(depth0,helpers,partials,data) {
    return "                My School\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "  <h2 class=\"sr-only\">Your profile</h2>\n  <div class=\"clearfix popup__section row border-bottom\">\n    <div class=\"col-xs-12 col-sm-4 no-margin\">\n      <div class=\"visible-xs pull-right\">\n        <a data-mz data-module=\"logout\" class=\"tes-btn tes-btn--primary t-log-out\" href=\""
    + alias3(((helper = (helper = helpers.logout || (depth0 != null ? depth0.logout : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"logout","hash":{},"data":data}) : helper)))
    + "\">Log out</a>\n      </div>\n      <div class=\"popup__subsection\">\n        <span class=\"user-avatar avatar--img-left\">\n          <span class=\"avatar__image\">\n            <span class=\"avatar__image-inner\">\n              <img\n                class=\"js-avatar\"\n                src=\""
    + alias3(((helper = (helper = helpers.avatarSmall || (depth0 != null ? depth0.avatarSmall : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"avatarSmall","hash":{},"data":data}) : helper)))
    + "\"\n                alt=\""
    + alias3(((helper = (helper = helpers.displayName || (depth0 != null ? depth0.displayName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"displayName","hash":{},"data":data}) : helper)))
    + "\"\n                width=\"40\"\n                height=\"40\"/>\n            </span>\n          </span>\n          <span class=\"avatar__name avatar__name--profile js-user-display-name\">"
    + alias3(((helper = (helper = helpers.displayName || (depth0 != null ? depth0.displayName : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"displayName","hash":{},"data":data}) : helper)))
    + "</span>\n        </span>\n      </div>\n    </div>\n    <div data-module=\"popup-links\" class=\"col-xs-12 col-sm-6 margin-top-sm\">\n      <ul class=\"profile__links-list \">\n        <li>\n          <a data-mz class=\"link link--unstyled profile__sublink\" href=\""
    + alias3(((helper = (helper = helpers.profile || (depth0 != null ? depth0.profile : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"profile","hash":{},"data":data}) : helper)))
    + "\">\n            Profile\n          </a>\n        </li>\n        <li>\n          <a data-mz class=\"link link--unstyled profile__sublink\" href=\""
    + alias3(((helper = (helper = helpers.account || (depth0 != null ? depth0.account : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"account","hash":{},"data":data}) : helper)))
    + "\">\n            Account\n          </a>\n        </li>\n        <li>\n          <a data-mz class=\"link link--unstyled profile__sublink\" href=\""
    + alias3(((helper = (helper = helpers.preferenceCentre || (depth0 != null ? depth0.preferenceCentre : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"preferenceCentre","hash":{},"data":data}) : helper)))
    + "\">\n            Email Preferences\n          </a>\n        </li>\n      </ul>\n    </div>\n    <div class=\"col-xs-12 col-sm-2 margin-top-xs hidden-xs\">\n      <div class=\"text-right\">\n        <a data-mz data-module=\"logout\" class=\"tes-btn tes-btn--primary tes-btn--sm t-log-out\" href=\""
    + alias3(((helper = (helper = helpers.logout || (depth0 != null ? depth0.logout : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"logout","hash":{},"data":data}) : helper)))
    + "\">Log out</a>\n      </div>\n    </div>\n  </div>\n  <div data-module=\"popup-links\" class=\"row popup__section popup__section-border\">\n    <div class=\"col-xs-12 "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.subscriptions : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.subscriptions : depth0),{"name":"unless","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " profile__subsection\">\n      <h3 class=\"h5 profile__subheading\">\n        <a data-mz class=\"link link--unstyled\" href=\""
    + alias3(((helper = (helper = helpers.myResources || (depth0 != null ? depth0.myResources : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"myResources","hash":{},"data":data}) : helper)))
    + "\">\n          My resources\n        </a>\n        <a data-mz class=\"margin-left-xs label label-primary label--primary link link--colored-dark\" href=\""
    + alias3(((helper = (helper = helpers.balance || (depth0 != null ? depth0.balance : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"balance","hash":{},"data":data}) : helper)))
    + "\">"
    + alias3(((helper = (helper = helpers.buyerBalance || (depth0 != null ? depth0.buyerBalance : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"buyerBalance","hash":{},"data":data}) : helper)))
    + "</a>\n      </h3>\n      <ul class=\"list-unstyled profile__links\">\n        <li>\n          <a data-mz class=\"profile__link link link--unstyled\" href=\""
    + alias3(((helper = (helper = helpers.authorDashboard || (depth0 != null ? depth0.authorDashboard : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"authorDashboard","hash":{},"data":data}) : helper)))
    + "\">\n            Author dashboard\n          </a>\n        </li>\n        <li>\n          <a data-mz class=\"profile__link link link--unstyled js-shop\"\n            href=\""
    + alias3(((helper = (helper = helpers.myShop || (depth0 != null ? depth0.myShop : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"myShop","hash":{},"data":data}) : helper)))
    + "\">\n              My shop\n          </a>\n        </li>\n        <li>\n          <a data-mz class=\"profile__link link link--unstyled\" href=\""
    + alias3(((helper = (helper = helpers.addResource || (depth0 != null ? depth0.addResource : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"addResource","hash":{},"data":data}) : helper)))
    + "\">\n            Add new resource\n          </a>\n        </li>\n        <li>\n          <a data-mz class=\"profile__link link link--unstyled\" href=\""
    + alias3(((helper = (helper = helpers.createBundle || (depth0 != null ? depth0.createBundle : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"createBundle","hash":{},"data":data}) : helper)))
    + "\">\n            Create new bundle\n          </a>\n        </li>\n        <li>\n          <a data-mz class=\"t-manage-sales profile__link link link--unstyled\" href=\""
    + alias3(((helper = (helper = helpers.manageSales || (depth0 != null ? depth0.manageSales : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"manageSales","hash":{},"data":data}) : helper)))
    + "\">\n            My sales\n          </a>\n        </li>\n      </ul>\n    </div>\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.subscriptions : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "    <div class=\"col-xs-12 "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.subscriptions : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.subscriptions : depth0),{"name":"unless","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " profile__subsection\">\n      <h3 class=\"h5 profile__subheading\">\n        <a data-mz class=\"link link--unstyled\" href=\""
    + alias3(((helper = (helper = helpers.myJobs || (depth0 != null ? depth0.myJobs : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"myJobs","hash":{},"data":data}) : helper)))
    + "\">My career</a>\n      </h3>\n      <ul class=\"list-unstyled profile__links\">\n        <li>\n          <a data-mz class=\"profile__link link link--unstyled\" href=\""
    + alias3(((helper = (helper = helpers.myJobs || (depth0 != null ? depth0.myJobs : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"myJobs","hash":{},"data":data}) : helper)))
    + "\">\n            My jobs\n          </a>\n        </li>\n        <li>\n          <a data-mz class=\"profile__link link link--unstyled\" href=\""
    + alias3(((helper = (helper = helpers.myCareerProfile || (depth0 != null ? depth0.myCareerProfile : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"myCareerProfile","hash":{},"data":data}) : helper)))
    + "\">\n              My career profile\n          </a>\n        </li>\n        <li>\n          <a data-mz class=\"profile__link link link--unstyled\" href=\""
    + alias3(((helper = (helper = helpers.myJobSearches || (depth0 != null ? depth0.myJobSearches : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"myJobSearches","hash":{},"data":data}) : helper)))
    + "\">\n            My searches\n          </a>\n        </li>\n        <li>\n          <a data-mz class=\"profile__link link link--unstyled\" href=\""
    + alias3(((helper = (helper = helpers.myCourses || (depth0 != null ? depth0.myCourses : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"myCourses","hash":{},"data":data}) : helper)))
    + "\">\n            My courses\n          </a>\n        </li>\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.orgId : depth0),{"name":"if","hash":{},"fn":this.program(8, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "      </ul>\n    </div>\n    <div class=\"col-xs-12 "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.subscriptions : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.subscriptions : depth0),{"name":"unless","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " profile__subsection\">\n      <h3 class=\"h5 profile__subheading\">\n        <a data-mz class=\"link link--unstyled\" href=\""
    + alias3(((helper = (helper = helpers.myCommunity || (depth0 != null ? depth0.myCommunity : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"myCommunity","hash":{},"data":data}) : helper)))
    + "\">\n          My community\n        </a>\n      </h3>\n      <ul class=\"list-unstyled profile__links\">\n        <li>\n          <a data-mz class=\"profile__link link link--unstyled\"\n            href=\""
    + alias3(((helper = (helper = helpers.myForums || (depth0 != null ? depth0.myForums : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"myForums","hash":{},"data":data}) : helper)))
    + "\">\n              My forums\n          </a>\n        </li>\n        <li>\n          <a data-mz class=\"profile__link link link--unstyled\"\n            href=\""
    + alias3(((helper = (helper = helpers.myThreads || (depth0 != null ? depth0.myThreads : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"myThreads","hash":{},"data":data}) : helper)))
    + "\">\n              My threads\n          </a>\n        </li>\n        <li>\n          <a data-mz class=\"profile__link link link--unstyled\"\n            href=\""
    + alias3(((helper = (helper = helpers.myConversations || (depth0 != null ? depth0.myConversations : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"myConversations","hash":{},"data":data}) : helper)))
    + "\">\n              My conversations\n          </a>\n        </li>\n        <li>\n          <a data-mz class=\"profile__link link link--unstyled\"\n            href=\""
    + alias3(((helper = (helper = helpers.myFollowers || (depth0 != null ? depth0.myFollowers : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"myFollowers","hash":{},"data":data}) : helper)))
    + "\">\n              Followers\n          </a>\n        </li>\n        <li>\n          <a data-mz class=\"profile__link link link--unstyled\"\n            href=\""
    + alias3(((helper = (helper = helpers.myFollowing || (depth0 != null ? depth0.myFollowing : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"myFollowing","hash":{},"data":data}) : helper)))
    + "\">\n              Following\n          </a>\n        </li>\n      </ul>\n    </div>\n  </div>\n";
},"useData":true});
module.exports["header-profile-v3-us"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "  <h2 class=\"sr-only\">Your profile</h2>\n\n  <div data-module=\"popup-links\" class=\"row popup__section popup__section-border\">\n\n    <div class=\"col-xs-12 col-sm-6 profile__subsection\">\n      <h3 class=\"h5 profile__subheading\">\n        <a data-mz class=\"link link--unstyled\" href=\""
    + alias3(((helper = (helper = helpers.myResources || (depth0 != null ? depth0.myResources : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"myResources","hash":{},"data":data}) : helper)))
    + "\">\n          My resources\n        </a>\n        <a data-mz class=\"margin-left-xs label label-primary label--primary\" href=\""
    + alias3(((helper = (helper = helpers.balance || (depth0 != null ? depth0.balance : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"balance","hash":{},"data":data}) : helper)))
    + "\">"
    + alias3(((helper = (helper = helpers.buyerBalance || (depth0 != null ? depth0.buyerBalance : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"buyerBalance","hash":{},"data":data}) : helper)))
    + "</a>\n      </h3>\n      <ul class=\"list-unstyled profile__links\">\n        <li>\n          <a data-mz class=\"profile__link link link--unstyled\" href=\""
    + alias3(((helper = (helper = helpers.authorDashboard || (depth0 != null ? depth0.authorDashboard : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"authorDashboard","hash":{},"data":data}) : helper)))
    + "\">\n            Author dashboard\n          </a>\n        </li>\n        <li>\n          <a data-mz class=\"profile__link link link--unstyled js-shop\" href=\""
    + alias3(((helper = (helper = helpers.myShop || (depth0 != null ? depth0.myShop : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"myShop","hash":{},"data":data}) : helper)))
    + "\">\n            My shop\n          </a>\n        </li>\n        <li>\n          <a data-mz class=\"profile__link link link--unstyled\" href=\""
    + alias3(((helper = (helper = helpers.addResource || (depth0 != null ? depth0.addResource : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"addResource","hash":{},"data":data}) : helper)))
    + "\">\n            Add new resource\n          </a>\n        </li>\n        <li>\n          <a data-mz class=\"profile__link link link--unstyled\" href=\""
    + alias3(((helper = (helper = helpers.createBundle || (depth0 != null ? depth0.createBundle : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"createBundle","hash":{},"data":data}) : helper)))
    + "\">\n            Create new bundle\n          </a>\n        </li>\n        <li>\n          <a data-mz class=\"t-manage-sales profile__link link link--unstyled\" href=\""
    + alias3(((helper = (helper = helpers.manageSales || (depth0 != null ? depth0.manageSales : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"manageSales","hash":{},"data":data}) : helper)))
    + "\">\n            My sales\n          </a>\n        </li>\n      </ul>\n    </div>\n\n  </div>\n  <div class=\"clearfix popup__section row\">\n    <div data-module=\"popup-links\" class=\"col-xs-8 col-sm-9 col-md-9 no-margin\">\n      <ul class=\"profile__links-list \">\n        <li>\n          <a data-mz class=\"link link--unstyled profile__sublink\" href=\""
    + alias3(((helper = (helper = helpers.account || (depth0 != null ? depth0.account : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"account","hash":{},"data":data}) : helper)))
    + "\">\n            Account\n          </a>\n        </li>\n        <li>\n          <a data-mz class=\"link link--unstyled profile__sublink\" href=\""
    + alias3(((helper = (helper = helpers.profile || (depth0 != null ? depth0.profile : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"profile","hash":{},"data":data}) : helper)))
    + "\">\n            Profile\n          </a>\n        </li>\n        <li>\n          <a data-mz class=\"link link--unstyled profile__sublink\" href=\""
    + alias3(((helper = (helper = helpers.preferenceCentre || (depth0 != null ? depth0.preferenceCentre : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"preferenceCentre","hash":{},"data":data}) : helper)))
    + "\">\n            Preferences\n          </a>\n        </li>\n      </ul>\n    </div>\n    <div class=\"col-xs-4 col-sm-3 col-md-3 text-right\">\n      <a data-mz data-module=\"logout\" class=\"btn--base btn--primary btn-sm text-xs t-log-out\" href=\""
    + alias3(((helper = (helper = helpers.logout || (depth0 != null ? depth0.logout : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"logout","hash":{},"data":data}) : helper)))
    + "\">Log out</a>\n    </div>\n  </div>\n";
},"useData":true});
});
},{"async-define":1,"handlebars":18}]},{},[19]);
